export const common = {
  // नेविगेशन
  'nav.features': 'विशेषताएँ',
  'nav.howItWorks': 'यह कैसे काम करता है',
  'nav.pricing': 'मूल्य निर्धारण',
  'nav.faq': 'अक्सर पूछे जाने वाले प्रश्न',
  'nav.aboutUs': 'हमारे बारे में',
  'nav.getStarted': 'शुरू करें',

  // हमारे बारे में अनुभाग
  'aboutUs.badge': "हमारे बारे में",
  'aboutUs.title': "IdeaVerdict क्यों मौजूद है",
  'aboutUs.line1': "आइडिया किसी का भी हो सकता है।",
  'aboutUs.line2': "पर कम लोग मानते हैं कि उनका टिकेगा नहीं।",
  'aboutUs.paragraph1':
    "ज़्यादातर आइडिया इसलिए फेल नहीं होते कि फाउंडर्स में हिम्मत नहीं थी। वे इसलिए फेल होते हैं क्योंकि कोई समय रहते सच नहीं बोलता। IdeaVerdict उसी खाई को भरता है — वो कड़वा सच जो आपके दोस्त नहीं देंगे, हम देते हैं।",
  'aboutUs.belief1a': "हम हाइप नहीं बेचते।",
  'aboutUs.belief1b': "हम मार्केट सिग्नल बेचते हैं।",
  'aboutUs.belief2a': "हम मोटिवेशन नहीं बेचते।",
  'aboutUs.belief2b': "हम मांग, प्रतिस्पर्धा और व्यवहार्यता का साफ़ विश्लेषण बेचते हैं।",
  'aboutUs.mission1': "हमारा काम आपके आइडिया को अच्छा दिखाना नहीं है।",
  'aboutUs.mission2': "हमारा काम बताना है कि वह वाकई अच्छा है या नहीं।",
  'aboutUs.analysis':
    "IdeaVerdict आइडिया को उन्हीं चीज़ों पर परखता है जो मायने रखती हैं — मार्केट स्ट्रक्चर, असली मांग, प्रतिस्पर्धा, ज़रूरी पूँजी, रेवेन्यू तक का समय, स्केलेबिलिटी। भावना नहीं। आशावाद नहीं। बस विश्लेषण।",
  'aboutUs.failure1': "ज़्यादातर बिज़नेस फेल होते हैं।",
  'aboutUs.failure2': "इसलिए नहीं कि उनके पीछे वाले लोग अक्षम थे —",
  'aboutUs.failure3': "बल्कि इसलिए कि किसी ने समय रहते कड़ा सवाल नहीं उठाया।",
  'aboutUs.clarity': "हम सवाल उठाने के लिए हैं।",
  'aboutUs.value1': "सीधा।",
  'aboutUs.value2': "ईमानदार।",
  'aboutUs.value3': "तेज़।",
  'aboutUs.confirm': "अगर आपके आइडिया में दम है, हम साथ देंगे।",
  'aboutUs.deny': "अगर नहीं, तो मुँह पर बोल देंगे।",
  'aboutUs.noApplause': "न तालियाँ।",
  'aboutUs.noSugarcoating': "न मिठास।",
  'aboutUs.noTheater': "न नाटक।",
  'aboutUs.noHype': "बस फैसला।",
  // हीरो अनुभाग
  'hero.badge': '60 सेकंड से कम में AI फैसला',
  'hero.title1': 'जाँच किए बिना',
  'hero.title2': 'मत बनाइए।',
  'hero.subtitle': 'IdeaVerdict आपके आइडिया को एक संशयवादी VC की तरह परखता है।',
  'hero.subtitleLine2': 'सेकंडों में ईमानदार फैसला — कोई हाइप नहीं, कोई चापलूसी नहीं।',
  'hero.cta': 'मेरा फैसला पाएँ',
  'hero.ctaSecondary': 'यह कैसे काम करता है',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'प्रति अनुरोध क्रेडिट',
  'hero.stat2Value': '7+',
  'hero.stat2Label': 'मूल्यांकन आयाम',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'ईमानदार और निजी',

  // विशेषताएँ अनुभाग
  'features.title1': 'उन संस्थापकों के लिए',
  'features.title2': 'जो सच',
  'features.title3': 'जानना चाहते हैं',
  'features.bullet1.title': 'सेकंडों में ईमानदार फैसला',
  'features.bullet1.description':
    'मजबूत, मिश्रित या कमज़ोर — हर रेटिंग के पीछे का कारण साथ में। कोई तालियाँ नहीं, कोई चाशनी नहीं, कोई नाटक नहीं।',
  'features.bullet2.title': 'जो मायने रखता है, उसी पर स्कोर',
  'features.bullet2.description':
    'आपके आइडिया का मूल्यांकन वास्तविक माँग, प्रतिस्पर्धा, ज़रूरी पूँजी, राजस्व तक का समय और स्केलेबिलिटी पर होता है — मूड पर नहीं।',
  'features.bullet3.title': 'फ़ैसले से निर्माण तक',
  'features.bullet3.description':
    'Builder मोड हरी झंडी पाई आइडिया को डेवलपर ब्रीफ़िंग में बदलता है: यूज़र फ़्लो, मुख्य फ़ीचर्स, तकनीकी नोट्स।',

  // यह कैसे काम करता है
  'howItWorks.title': 'यह कैसे काम करता है',
  'howItWorks.subtitle': 'अपने व्यावसायिक क्षेत्र के बारे में स्पष्टता के लिए चार कदम।',
  'howItWorks.step1Title': 'एक योजना चुनें',
  'howItWorks.step1Desc': 'स्टार्टर, प्रो या बिल्डर – आपकी समीक्षा की गहराई पर निर्भर करता है।',
  'howItWorks.step2Title': 'AI से पूछें',
  'howItWorks.step2Desc': 'क्षेत्र के बारे में अपने प्रश्न पूछें। प्रत्येक अनुरोध पर 30 क्रेडिट लगते हैं।',
  'howItWorks.step3Title': 'ईमानदार फैसला प्राप्त करें',
  'howItWorks.step3Desc': 'AI रेटिंग देता है: अच्छा, औसत या बुरा। कोई मीठी बातें नहीं।',
  'howItWorks.step4Title': 'निर्णय लें',
  'howItWorks.step4Desc': 'अब आप जानते हैं कि आगे बढ़ना उचित है या नहीं।',

  // मूल्य निर्धारण
  'pricing.title': 'मूल्य निर्धारण',
  'pricing.subtitle': 'अपनी समीक्षा गहराई के अनुसार योजना चुनें।',
  'pricing.monthly': 'मासिक',
  'pricing.yearly': 'वार्षिक',
  'pricing.yearlyDiscount': 'वार्षिक सदस्यता:',
  'pricing.yearlyDiscountValue': '-20% छूट',
  'pricing.perMonth': 'प्रति माह',
  'pricing.selectPlan': 'योजना चुनें',
  'pricing.mostPopular': 'सबसे लोकप्रिय',
  'pricing.footer':
    'सभी मूल्य CHF में। क्रेडिट केवल सफल AI प्रतिक्रियाओं के लिए काटे जाते हैं।',

  // Pricing Features
  'pricing.feature1': 'निचे विचार उत्पन्न करें',
  'pricing.feature2': 'निचे परिष्कृत करें',
  'pricing.feature3': 'बाजार वास्तविकता जांच',
  'pricing.feature4': 'प्रतिस्पर्धा आकलन',
  'pricing.feature5': 'समय आकलन',
  'pricing.feature6': 'ईमानदार फैसला',
  'pricing.feature7': 'निजी सत्र',
  'pricing.feature8': 'इतिहास और निर्यात',
  'pricing.feature9': 'आला विचार',
  'pricing.feature10': 'प्रवृत्ति विश्लेषण',
  'pricing.feature11': 'सुधार सुझाव',
  'pricing.feature12': 'वैकल्पिक निचे',
  'pricing.feature13': 'विस्तृत बाजार विश्लेषण',
  'pricing.feature14': 'प्राथमिकता समर्थन',
  'pricing.feature15': 'उन्नत फ़िल्टर',
  'pricing.feature16': 'सत्र पसंदीदा',
  'pricing.feature17': 'विश्लेषण अलर्ट',
  'pricing.feature18': 'निजी सफलता प्रबंधक',

  // स्टार्टर योजना
  'pricing.starter.name': 'स्टार्टर',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'AI निचे चैटबोट तक पहुंच',
  'pricing.starter.credits': 'प्रति माह 2,500 क्रेडिट',
  'pricing.starter.feature1': 'निचे विचार उत्पन्न करें',
  'pricing.starter.feature2': 'निचे परिष्कृत करें',
  'pricing.starter.feature3': 'बाजार वास्तविकता जांच',
  'pricing.starter.feature4': 'प्रतिस्पर्धा आकलन',
  'pricing.starter.feature5': 'समय आकलन',
  'pricing.starter.feature6': 'ईमानदार फैसला',
  'pricing.starter.feature7': 'निजी सत्र',
  'pricing.starter.feature8': 'इतिहास और निर्यात',

  // प्रो योजना
  'pricing.pro.name': 'प्रो',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'AI निचे चैटबोट तक पहुंच',
  'pricing.pro.credits': 'प्रति माह 5,000 क्रेडिट',
  'pricing.pro.feature1': 'सभी स्टार्टर सुविधाएँ',
  'pricing.pro.feature2': 'गहन समीक्षा के लिए अधिक क्रेडिट',
  'pricing.pro.feature3': 'सुधार सुझाव',
  'pricing.pro.feature4': 'वैकल्पिक निचे',
  'pricing.pro.feature5': 'विस्तृत बाजार विश्लेषण',
  'pricing.pro.feature6': 'प्राथमिकता समर्थन',
  'pricing.pro.feature7': 'उन्नत फ़िल्टर',
  'pricing.pro.feature8': 'सत्र पसंदीदा',

  // बिल्डर योजना
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "सभी फ़ीचर्स + Builder मोड",
  'pricing.builder.credits': "प्रति माह 10,000 क्रेडिट",
  'pricing.builder.feature1': 'सभी प्रो सुविधाएँ',
  'pricing.builder.feature2': 'असीमित AI अनुरोध',
  'pricing.builder.feature3': 'बिल्डर मोड: डेवलपर ब्रीफिंग',
  'pricing.builder.feature4': 'संरचित परियोजना अवलोकन',
  'pricing.builder.feature5': 'उपयोगकर्ता प्रवाह और मुख्य विशेषताएँ',
  'pricing.builder.feature6': 'तकनीकी नोट्स',
  'pricing.builder.feature7': 'गैर-लक्ष्य परिभाषित करें',
  'pricing.builder.feature8': 'उचित उपयोग दर सीमा',
  'pricing.builder.limitNote': 'उचित उपयोग सीमा',
  'pricing.monthlyReset': 'मासिक रीसेट',

  // मोडल
  'pricing.modal.selected': 'चयनित',
  'pricing.modal.comingSoon':
    'पंजीकरण और भुगतान प्रसंस्करण जल्द ही उपलब्ध होगा।',
  'pricing.modal.patience':
    'हम आपको एक सुरक्षित और सहज अनुभव प्रदान करने के लिए काम कर रहे हैं। कृपया धैर्य रखें।',
  'pricing.modal.understood': 'समझ गया',

  // अक्सर पूछे जाने वाले प्रश्न
  'faq.title': 'अक्सर पूछे जाने वाले प्रश्न',
  'faq.subtitle': 'ईमानदारी से और आलोचनात्मक रूप से उत्तर दिया गया।',
  'faq.q1': "IdeaVerdict असल में करता क्या है?",
  'faq.a1': "यह आपके बिज़नेस आइडिया को उन चीज़ों पर परखता है जो नतीजे तय करती हैं — असली मांग, प्रतिस्पर्धा, ज़रूरी पूँजी, मार्केट तक का समय और स्केलेबिलिटी।\nअगर आइडिया टिकता है, तो हम बताते हैं कि उसे और धार कैसे दें।\nअगर नहीं, तो वह भी बता देते हैं।",
  'faq.q2': "क्या आप आइडिया भी देते हैं?",
  'faq.a2': "हाँ — पर हवा में से नहीं निकाले जाते।\nआइडिया असली मार्केट गैप से आते हैं, इस हफ़्ते के ट्रेंड से नहीं।",
  'faq.q3': "क्या आप मौजूदा बिज़नेस मॉडल बेहतर करते हैं?",
  'faq.a3': "हाँ, अगर सुधारने लायक कुछ हो।\nहम टूटे आइडिया चमकाते नहीं — हम उन्हें मज़बूत करते हैं जिनकी नींव पहले से है।",
  'faq.q4': "आप दूसरे AI टूल्स से अलग कैसे हैं?",
  'faq.a4': "ज़्यादातर AI टूल आपको बताते हैं कि आपका आइडिया शानदार है।\nहम बताते हैं कि वह वाकई है या नहीं।\nफ़र्क: उत्साह की जगह यथार्थ।",
  'faq.q5': "क्या इससे सफलता की गारंटी है?",
  'faq.a5': "नहीं।\nहम बुरे दांव से बचने में मदद करते हैं — जोखिम मिटता नहीं, पर आप आँख खोलकर अंदर जाते हैं।",
  'faq.q6': "IdeaVerdict किसके लिए है?",
  'faq.a6': "लॉन्च से पहले फाउंडर्स के लिए।\nसाइड-प्रोजेक्ट वीकेंड से पहले बिल्डर्स के लिए।\nअगले दांव से पहले ऑपरेटर्स के लिए।\nसाइन करने से पहले इन्वेस्टर्स के लिए।\n\nहर उस इंसान के लिए जो प्रतिबद्धता से पहले स्पष्टता चाहता है।",
  'faq.q7': "अगर मुझे सिर्फ़ वैलिडेशन चाहिए तो?",
  'faq.a7': "तो IdeaVerdict ग़लत टूल है।\nहम ईमानदार फैसला देते हैं, ढाँढस नहीं।",
  'faq.q8': "विश्लेषण असल में कितना ईमानदार है?",
  'faq.a8': "जितना डेटा होने दे, उतना ईमानदार।\nहम कमज़ोर फैसले को भावनाओं के लिए नरम नहीं करते।",
  'faq.q9': "क्या यह असली मार्केट रिसर्च की जगह लेता है?",
  'faq.a9': "नहीं।\nयह निवेश से पहले की तेज़ रणनीतिक जाँच है — 50-पेज की मार्केट स्टडी नहीं।",
  'faq.q10': "इतने सीधे क्यों?",
  'faq.a10': "क्योंकि ग़लत चीज़ बनाने में महीने लगते हैं।\nईमानदार फैसले में मिनट।\n\nहम मिनट चुनते हैं।",
  // फूटर
  'footer.description':
    'IdeaVerdict आपको अच्छा महसूस कराने के लिए नहीं है। यह आपको सही फैसला लेने में मदद के लिए है।',
  'footer.product': 'उत्पाद',
  'footer.aiAssistant': 'AI सहायक',
  'footer.howItWorks': 'यह कैसे काम करता है',
  'footer.pricing': 'मूल्य निर्धारण',
  'footer.faq': 'अक्सर पूछे जाने वाले प्रश्न',
  'footer.legal': 'कानूनी',
  'footer.privacy': 'गोपनीयता',
  'footer.terms': 'शर्तें',
  'footer.imprint': 'छाप',
  'footer.support': 'समर्थन',
  'footer.contact': 'संपर्क करें',
  'footer.documentation': 'प्रलेखन',
  'footer.copyright': '© 2026 IdeaVerdict. सर्वाधिकार सुरक्षित।',

  // AI सहायक
  'aiAssistant.title': 'AI निचे सहायक',
  'aiAssistant.subtitle': 'निचे के बारे में पूछें',
  'aiAssistant.welcomeMessage':
    'नमस्ते! अपना विचार बताएं या मुझसे किसी क्षेत्र के बारे में पूछें। मैं आपको स्पष्ट और ईमानदार मूल्यांकन दूंगा।',
  'aiAssistant.demoResponse':
    'यह एक डेमो है। वास्तविक AI मूल्यांकन प्राप्त करने के लिए, कृपया पंजीकरण करें और एक योजना चुनें।',
  'aiAssistant.placeholder': 'अपना विचार बताएं...',

  // हेडर और साइडबार
  'dashboard.header.title': 'डैशबोर्ड',
  'dashboard.header.aiAssistant': 'आपका AI सहायक',
  'header.logout': 'साइन आउट',
  'dashboard.sidebar.overview': 'अवलोकन',
  'dashboard.sidebar.aiChat': 'AI सहायक',
  'dashboard.sidebar.newAnalysis': 'AI सहायक',
  'dashboard.sidebar.history': 'इतिहास',
  'dashboard.sidebar.credits': 'क्रेडिट',
  'dashboard.sidebar.settings': 'सेटिंग्स',

  // डैशबोर्ड अवलोकन
  'dashboard.overview.welcome': 'वापस स्वागत है, {{name}}',
  'dashboard.overview.subtitle':
    'यहाँ आपकी गतिविधि का एक त्वरित अवलोकन है',

  // डैशबोर्ड आंकड़े
  'dashboard.stats.creditsRemaining': 'शेष क्रेडिट',
  'dashboard.stats.totalAnalyses': 'कुल विश्लेषण',
  'dashboard.stats.goodRatings': 'सकारात्मक रेटिंग',
  'dashboard.stats.nextReset': 'अगला रीसेट',
  'dashboard.stats.days': 'दिन',

  // त्वरित क्रियाएँ
  'dashboard.quickActions.title': 'त्वरित क्रियाएँ',
  'dashboard.quickActions.checkNewIdea': 'विचार जांचें',
  'dashboard.quickActions.checkNewIdeaDesc':
    'किसी मौजूदा व्यावसायिक विचार का विश्लेषण करें',
  'dashboard.quickActions.generateIdea': 'विचार उत्पन्न करें',
  'dashboard.quickActions.generateIdeaDesc':
    'एक नया लाभदायक क्षेत्र खोजें',
  'dashboard.quickActions.builderBriefing': 'बिल्डर ब्रीफिंग',
  'dashboard.quickActions.builderBriefingDesc':
    'एक विचार को डेवलपर-तैयार ब्रीफिंग में बदलें',
  'dashboard.quickActions.premiumOnly': 'केवल बिल्डर',

  // चैट हेडर
  'chat.title': 'AI निचे सहायक',
  'chat.subtitle':
    'क्षेत्रों के बारे में प्रश्न पूछें। मैं आलोचनात्मक और ईमानदारी से मूल्यांकन करता हूँ।',
  'chat.creditsLabel': 'क्रेडिट',

  // चैट स्वागत
  'chat.welcomeTitle': 'AI निचे सहायक में आपका स्वागत है',
  'chat.welcomeDesc':
    'अपना विचार बताएं या किसी क्षेत्र के बारे में पूछें। मैं इसका ईमानदारी से मूल्यांकन करूंगा: अच्छा, औसत या बुरा।',
  'chat.aiWelcome':
    'नमस्ते! अपना विचार बताएं या मुझसे किसी क्षेत्र के बारे में पूछें। मैं आपको स्पष्ट और ईमानदार मूल्यांकन दूंगा।',

  // चैट सुझाव
  'chat.suggestion1': 'मैं फ्रीलांसरों के लिए इनवॉइस मैनेज करने का SaaS टूल बनाना चाहता हूं। क्या यह अच्छा निच है?',
  'chat.suggestion2': 'मुझे कम प्रतिस्पर्धा वाला ऑनलाइन बिज़नेस ढूंढो जो $500 में बिना कोडिंग के शुरू हो सके।',
  'chat.suggestion3': 'इसका मूल्यांकन करो: व्यस्त माता-पिता के लिए AI-पावर्ड मील प्लानिंग ऐप जिनकी डाइट में पाबंदियां हैं।',
  'chat.suggestion4': 'मैं Etsy पर छोटे बिज़नेस मालिकों के लिए डिजिटल टेम्पलेट बेचना चाहता हूं। इस निच का ईमानदारी से विश्लेषण करो।',

  // चैट क्रियाएँ
  'chat.newConversation': 'नई बातचीत',
  'chat.today': 'आज',
  'chat.yesterday': 'कल',
  'chat.thisWeek': 'इस सप्ताह',
  'chat.thisMonth': 'इस महीने',
  'chat.older': 'पुराना',
  'chat.messages': 'संदेश',
  'chat.renameConversation': 'नाम बदलें',
  'chat.deleteConversation': 'हटाएं',
  'chat.cancel': 'रद्द करें',
  'chat.rename': 'नाम बदलें',
  'chat.delete': 'हटाएं',
  'chat.favorite': 'पसंदीदा जोड़ें',
  'chat.unfavorite': 'पसंदीदा हटाएं',
  'chat.searchSessions': 'बातचीत खोजें...',
  'chat.noResults': 'कोई परिणाम नहीं मिला',
  'chat.noSessions': 'अभी कोई बातचीत नहीं',
  'chat.enterNewName': 'नया नाम दर्ज करें...',
  'chat.deleteConfirmMessage':
    'क्या आप वाकई इस बातचीत को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।',

  // चैट इनपुट और त्रुटियाँ
  'chat.inputPlaceholder': 'अपना प्रश्न टाइप करें… (30 क्रेडिट लगते हैं)',
  'chat.send': 'भेजें',
  'chat.voice': 'बोलें',
  'chat.listeningPlaceholder': 'मैं सुन रहा हूँ... अब बोलें।',
  'chat.stopListening': 'सुनना बंद करें',
  'chat.recording': 'रिकॉर्डिंग...',
  'chat.speechNotSupported': 'आपका ब्राउज़र आवाज पहचान का समर्थन नहीं करता है।',
  'chat.microphonePermissionDenied': 'माइक्रोफोन पहुंच अस्वीकृत। कृपया ब्राउज़र सेटिंग्स में अनुमति दें।',
  'chat.errorNotEnoughCredits':
    'पर्याप्त क्रेडिट नहीं। कृपया अपनी योजना अपग्रेड करें या अगले रीसेट की प्रतीक्षा करें।',
  'chat.errorAiFailed': 'AI प्रतिक्रिया विफल। कोई क्रेडिट नहीं काटा गया।',
  'chat.errorRateLimit': 'बहुत अधिक अनुरोध। कृपया एक क्षण प्रतीक्षा करें।',

  // रेटिंग
  'rating.good': 'अच्छा',
  'rating.medium': 'औसत',
  'rating.bad': 'बुरा',

  // प्रमाणीकरण पृष्ठ
  'auth.branding.headline1': 'हर विचार अच्छा नहीं होता।',
  'auth.branding.headline2': 'हम आपको ईमानदारी से बताते हैं।',
  'auth.branding.subtitle':
    'व्यावसायिक क्षेत्रों के लिए एक निर्णय AI। स्पष्ट। आलोचनात्मक। कोई मीठी बातें नहीं।',
  'auth.benefits.privacy.title': '100% निजी',
  'auth.benefits.privacy.desc':
    'आपके विचार पूरी तरह से निजी और सुरक्षित रहते हैं।',
  'auth.benefits.honest.title': 'ईमानदार AI',
  'auth.benefits.honest.desc':
    'कोई मीठी बातें नहीं – केवल स्पष्ट, आलोचनात्मक प्रतिक्रिया।',
  'auth.benefits.fast.title': 'तेज परिणाम',
  'auth.benefits.fast.desc': 'मिनटों में अपने क्षेत्र के बारे में स्पष्टता प्राप्त करें।',
  'auth.trust.users': 'सक्रिय उपयोगकर्ता',
  'auth.trust.ideas': 'विश्लेषित विचार',
  'auth.trust.rating': 'उपयोगकर्ता रेटिंग',
  'auth.login.title': 'लॉगिन',
  'auth.login.headline': 'वापस स्वागत है',
  'auth.login.subtitle': 'अपनी यात्रा जारी रखने के लिए साइन इन करें।',
  'auth.login.forgotPassword': 'पासवर्ड भूल गए?',
  'auth.login.submit': 'साइन इन करें',
  'auth.login.noAccount': 'अभी तक कोई खाता नहीं?',
  'auth.login.signUp': 'साइन अप करें',
  'auth.register.title': 'पंजीकरण करें',
  'auth.register.headline': 'अपना खाता बनाएं',
  'auth.register.subtitle':
    'आज ही अपने व्यावसायिक विचारों का विश्लेषण शुरू करें।',
  'auth.register.submit': 'खाता बनाएं',
  'auth.register.hasAccount': 'पहले से खाता है?',
  'auth.register.signIn': 'साइन इन करें',
  'auth.fields.name': 'पूरा नाम',
  'auth.fields.email': 'ईमेल पता',
  'auth.fields.password': 'पासवर्ड',
  'auth.fields.confirmPassword': 'पासवर्ड की पुष्टि करें',
  'auth.fields.selectPlan': 'अपनी योजना चुनें',
  'auth.fields.testCode': 'लॉगिन करें और मुफ्त में परीक्षण करें',
  'auth.placeholders.name': 'अपना नाम दर्ज करें',
  'auth.placeholders.email': 'अपना ईमेल दर्ज करें',
  'auth.placeholders.password': 'अपना पासवर्ड दर्ज करें',
  'auth.placeholders.confirmPassword': 'अपने पासवर्ड की पुष्टि करें',
  'auth.placeholders.testCode': 'परीक्षण कोड दर्ज करें',
  'auth.terms.accept': 'मैं स्वीकार करता हूँ',
  'auth.terms.terms': 'नियम और शर्तें',
  'auth.privacy.accept': 'मैं स्वीकार करता हूँ',
  'auth.privacy.policy': 'गोपनीयता नीति',
  'auth.errors.nameRequired': 'नाम आवश्यक है',
  'auth.errors.emailRequired': 'ईमेल आवश्यक है',
  'auth.errors.emailInvalid': 'कृपया एक वैध ईमेल दर्ज करें',
  'auth.errors.passwordRequired': 'पासवर्ड आवश्यक है',
  'auth.errors.passwordLength': 'पासवर्ड कम से कम 8 अक्षरों का होना चाहिए',
  'auth.errors.passwordMismatch': 'पासवर्ड मेल नहीं खाते',
  'auth.errors.invalidCode': 'अमान्य या समाप्त हो चुका कोड',
  'auth.errors.registrationCodeOnly': 'यह कोड केवल पंजीकरण के लिए है',
  'auth.errors.verificationFailed': 'कोड सत्यापित करने में त्रुटि। कृपया पुनः प्रयास करें।',
  'auth.loading': 'कृपया प्रतीक्षा करें...',
  'auth.or': 'या इसके साथ जारी रखें',
  'auth.social.google': 'Google के साथ जारी रखें',
  'auth.social.apple': 'Apple के साथ जारी रखें',
  'auth.actions.verify': 'सत्यापित करें',
  'auth.testCode.activated': 'परीक्षण कोड सक्रिय!',
  'auth.testCode.days': 'दिन',
  'auth.testCode.months': 'महीने',
  'auth.testCode.freeAccess': 'मुफ्त पहुंच',
  'auth.testCode.credits': 'क्रेडिट',

  // ईमेल सत्यापन
  'auth.verification.title': 'ईमेल सत्यापित करें',
  'auth.verification.headline': 'अपना इनबॉक्स जांचें',
  'auth.verification.subtitle': 'हमने एक सत्यापन कोड भेजा है:',
  'auth.verification.codeLabel': 'सत्यापन कोड',
  'auth.verification.codePlaceholder': '6-अंकीय कोड दर्ज करें',
  'auth.verification.submit': 'ईमेल सत्यापित करें',
  'auth.verification.resend': 'कोड पुनः भेजें',
  'auth.verification.resendIn': 'पुनः भेजें',
  'auth.verification.seconds': 'सेकंड',
  'auth.verification.success': 'ईमेल सफलतापूर्वक सत्यापित!',
  'auth.verification.error': 'अमान्य कोड। कृपया पुनः प्रयास करें।',
  'auth.verification.expired': 'कोड समाप्त हो गया। कृपया एक नया अनुरोध करें।',
  'auth.verification.sent': 'नया कोड भेजा गया!',
  'auth.verification.checkSpam':
    'प्राप्त नहीं हुआ? अपना स्पैम फ़ोल्डर जांचें।',

  // पासवर्ड भूल गए
  'auth.forgot.title': 'पासवर्ड भूल गए',
  'auth.forgot.headline': 'अपना पासवर्ड रीसेट करें',
  'auth.forgot.subtitle':
    'अपना ईमेल पता दर्ज करें और हम आपको एक रीसेट लिंक भेजेंगे।',
  'auth.forgot.submit': 'रीसेट लिंक भेजें',
  'auth.forgot.backToLogin': 'लॉगिन पर वापस जाएं',
  'auth.forgot.success': 'ईमेल भेजा गया!',
  'auth.forgot.successMessage':
    'हमने आपको अपना पासवर्ड रीसेट करने के निर्देशों के साथ एक ईमेल भेजा है।',
  'auth.forgot.checkInbox': 'अपना इनबॉक्स जांचें',

  // पासवर्ड रीसेट करें
  'auth.reset.title': 'नया पासवर्ड',
  'auth.reset.headline': 'नया पासवर्ड सेट करें',
  'auth.reset.subtitle': 'अपना नया पासवर्ड दर्ज करें।',
  'auth.reset.newPassword': 'नया पासवर्ड',
  'auth.reset.confirmNewPassword': 'नए पासवर्ड की पुष्टि करें',
  'auth.reset.submit': 'पासवर्ड बदलें',
  'auth.reset.success': 'पासवर्ड सफलतापूर्वक बदला गया!',
  'auth.reset.successMessage':
    'अब आप अपने नए पासवर्ड के साथ साइन इन कर सकते हैं।',
  'auth.reset.loginNow': 'अभी साइन इन करें',

  // कानूनी पृष्ठ
  'legal.backToAuth': 'लॉगिन पर वापस जाएं',
  'legal.allRightsReserved': 'सर्वाधिकार सुरक्षित।',

  // शर्तें पृष्ठ
  'legal.terms.title': 'नियम और शर्तें',
  'legal.terms.lastUpdated': 'अंतिम अपडेट',
  'legal.terms.section1.title': '1. दायरा',
  'legal.terms.section1.content':
    'ये नियम और शर्तें NicheFinder (बाद में "प्रदाता" के रूप में संदर्भित) और उपयोगकर्ता (बाद में "ग्राहक" के रूप में संदर्भित) के बीच AI-संचालित क्षेत्र विश्लेषण प्लेटफ़ॉर्म के उपयोग से संबंधित सभी अनुबंधों पर लागू होती हैं।',
  'legal.terms.section2.title': '2. सेवा विवरण',
  'legal.terms.section2.content':
    'प्रदाता एक AI-आधारित प्लेटफ़ॉर्म प्रदान करता है जो व्यावसायिक विचारों और क्षेत्रों का विश्लेषण और मूल्यांकन करता है। सेवाओं में शामिल हैं:',
  'legal.terms.section2.item1': 'व्यावसायिक विचारों का AI-संचालित विश्लेषण',
  'legal.terms.section2.item2': 'बाजार क्षमता और प्रतिस्पर्धा का मूल्यांकन',
  'legal.terms.section2.item3': 'क्षेत्र सुझावों का उत्पादन',
  'legal.terms.section2.item4': 'डेवलपर ब्रीफिंग का निर्माण (बिल्डर पैकेज)',
  'legal.terms.section3.title': '3. अनुबंध समापन और पंजीकरण',
  'legal.terms.section3.content':
    'अनुबंध प्लेटफ़ॉर्म पर पंजीकरण और एक पैकेज के चयन के माध्यम से संपन्न होता है। ग्राहक पुष्टि करता है:',
  'legal.terms.section3.item1': 'वैध आयु और पूर्ण कानूनी क्षमता का होना',
  'legal.terms.section3.item2': 'पंजीकरण के दौरान सत्य जानकारी प्रदान करना',
  'legal.terms.section3.item3': 'पहुंच प्रमाणपत्रों का सुरक्षित भंडारण',
  'legal.terms.section4.title': '4. क्रेडिट और बिलिंग',
  'legal.terms.section4.content':
    'AI सुविधाओं का उपयोग क्रेडिट प्रणाली पर आधारित है। प्रत्येक AI क्वेरी पर 30 क्रेडिट लगते हैं। क्रेडिट केवल सफल प्रतिक्रिया पर काटे जाते हैं। अप्रयुक्त क्रेडिट बिलिंग अवधि के अंत में समाप्त हो जाते हैं और वापस नहीं किए जाते हैं।',
  'legal.terms.section5.title': '5. अस्वीकरण',
  'legal.terms.section5.content':
    'AI मूल्यांकन केवल निर्णय सहायता के रूप में कार्य करते हैं और व्यावसायिक सफलता की गारंटी नहीं देते हैं। प्रदाता AI विश्लेषणों के आधार पर लिए गए निर्णयों के लिए उत्तरदायी नहीं है। इरादे और घोर लापरवाही के लिए दायित्व अप्रभावित रहता है।',
  'legal.terms.section6.title': '6. डेटा संरक्षण और गोपनीयता',
  'legal.terms.section6.content':
    'सभी प्रस्तुत व्यावसायिक विचारों को गोपनीय रूप से व्यवहार किया जाता है और तीसरे पक्षों के साथ साझा नहीं किया जाता है। व्यक्तिगत डेटा का प्रसंस्करण हमारी गोपनीयता नीति और लागू डेटा संरक्षण कानूनों के अनुसार किया जाता है।',
  'legal.terms.section7.title': '7. समाप्ति',
  'legal.terms.section7.content':
    'ग्राहक किसी भी समय वर्तमान बिलिंग अवधि के अंत में अपनी सदस्यता रद्द कर सकता है। इन नियमों के उल्लंघन के मामले में, प्रदाता प्लेटफ़ॉर्म तक पहुंच को अवरुद्ध करने का अधिकार सुरक्षित रखता है।',
  'legal.terms.section8.title': '8. अंतिम प्रावधान',
  'legal.terms.section8.content':
    'स्विस कानून लागू होता है। क्षेत्राधिकार का स्थान ज्यूरिख, स्विट्जरलैंड है। यदि इन नियमों के व्यक्तिगत प्रावधान अमान्य हैं, तो शेष प्रावधानों की वैधता अप्रभावित रहती है।',
  'legal.terms.contact.title': 'नियमों के बारे में प्रश्न?',
  'legal.terms.contact.content':
    'यदि आपके पास इन नियमों और शर्तों के बारे में प्रश्न हैं, तो कृपया हमसे संपर्क करें:',

  // गोपनीयता पृष्ठ
  'legal.privacy.title': 'गोपनीयता नीति',
  'legal.privacy.section1.title': '1. डेटा नियंत्रक',
  'legal.privacy.section1.content':
    'इस वेबसाइट के लिए डेटा नियंत्रक NicheFinder, ज्यूरिख, स्विट्जरलैंड है। हम आपके व्यक्तिगत डेटा की सुरक्षा को बहुत गंभीरता से लेते हैं और आपके व्यक्तिगत डेटा के साथ गोपनीय रूप से और वैधानिक डेटा संरक्षण नियमों के अनुसार व्यवहार करते हैं।',
  'legal.privacy.section2.title': '2. एकत्रित डेटा',
  'legal.privacy.section2.content':
    'हम निम्नलिखित व्यक्तिगत डेटा एकत्र और संसाधित करते हैं:',
  'legal.privacy.section2.item1':
    'पंजीकरण डेटा: नाम, ईमेल पता, पासवर्ड (एन्क्रिप्टेड)',
  'legal.privacy.section2.item2':
    'उपयोग डेटा: आईपी पता, ब्राउज़र प्रकार, पहुंच समय',
  'legal.privacy.section2.item3':
    'व्यावसायिक विचार और क्षेत्र क्वेरी (अनाम रूप से संग्रहीत)',
  'legal.privacy.section2.item4':
    'भुगतान जानकारी (सुरक्षित तृतीय-पक्ष प्रदाताओं के माध्यम से)',
  'legal.privacy.section3.title': '3. डेटा प्रसंस्करण का उद्देश्य',
  'legal.privacy.section3.content':
    'आपका डेटा निम्नलिखित उद्देश्यों के लिए उपयोग किया जाता है:',
  'legal.privacy.section3.item1':
    'हमारी AI सेवाओं का प्रावधान और सुधार',
  'legal.privacy.section3.item2':
    'खाता प्रबंधन और प्रमाणीकरण',
  'legal.privacy.section3.item3':
    'बिलिंग और भुगतान प्रसंस्करण',
  'legal.privacy.section4.title': '4. डेटा सुरक्षा',
  'legal.privacy.section4.content':
    'हम आपके डेटा को हेरफेर, हानि, विनाश या अनधिकृत पहुंच से बचाने के लिए तकनीकी और संगठनात्मक सुरक्षा उपायों को लागू करते हैं। सभी डेटा स्थानांतरण SSL/TLS के माध्यम से एन्क्रिप्टेड हैं।',
  'legal.privacy.section5.title': '5. आपके व्यावसायिक विचारों की गोपनीयता',
  'legal.privacy.section5.content':
    'आपके प्रस्तुत व्यावसायिक विचारों और क्षेत्र क्वेरी के साथ सख्ती से गोपनीय व्यवहार किया जाता है। वे तीसरे पक्षों के साथ साझा नहीं किए जाते हैं, प्रशिक्षण उद्देश्यों के लिए उपयोग नहीं किए जाते हैं, और अनुरोध पर पूरी तरह से हटाए जा सकते हैं। आपके विचार आपके हैं।',
  'legal.privacy.section6.title': '6. आपके अधिकार',
  'legal.privacy.section6.content':
    'आपके पास अपने व्यक्तिगत डेटा के संबंध में निम्नलिखित अधिकार हैं:',
  'legal.privacy.section6.item1': 'संग्रहीत डेटा तक पहुंच का अधिकार',
  'legal.privacy.section6.item2': 'गलत डेटा के सुधार का अधिकार',
  'legal.privacy.section6.item3': 'अपने डेटा को हटाने का अधिकार',
  'legal.privacy.section6.item4': 'डेटा पोर्टेबिलिटी का अधिकार',
  'legal.privacy.section7.title': '7. कुकीज़',
  'legal.privacy.section7.content':
    'हमारी वेबसाइट केवल तकनीकी रूप से आवश्यक कुकीज़ का उपयोग प्रमाणीकरण और सत्र प्रबंधन के लिए करती है। हम आपकी स्पष्ट सहमति के बिना ट्रैकिंग कुकीज़ या तृतीय-पक्ष विश्लेषण टूल का उपयोग नहीं करते हैं।',
  'legal.privacy.section8.title': '8. इस गोपनीयता नीति में परिवर्तन',
  'legal.privacy.section8.content':
    'हम बदली हुई कानूनी आवश्यकताओं का पालन करने या सेवा में परिवर्तन होने पर इस गोपनीयता नीति को अनुकूलित करने का अधिकार सुरक्षित रखते हैं। वर्तमान संस्करण हमेशा इस पृष्ठ पर पाया जा सकता है।',
  'legal.privacy.contact.title': 'गोपनीयता के बारे में प्रश्न?',
  'legal.privacy.contact.content':
    'यदि आपके पास आपके व्यक्तिगत डेटा के प्रसंस्करण के बारे में प्रश्न हैं, तो कृपया हमसे संपर्क करें:',

  'auth.passwordStrength.label': 'पासवर्ड ताकत',
  'auth.passwordStrength.weak': 'कमजोर',
  'auth.passwordStrength.medium': 'मध्यम',
  'auth.passwordStrength.strong': 'मजबूत',
  'auth.passwordStrength.veryStrong': 'बहुत मजबूत',
  'auth.passwordStrength.minLength': 'न्यूनतम 8 अक्षर',
  'auth.passwordStrength.uppercase': 'बड़ा अक्षर',
  'auth.passwordStrength.number': 'संख्या',
  'auth.passwordStrength.special': 'विशेष वर्ण',

  trial: {
    subtitle: 'निःशुल्क परीक्षण',
    upgrade: 'अभी अपग्रेड करें',
    creditsRemaining: 'क्रेडिट शेष',
    inputHint: 'परीक्षण संस्करण - कोई बातचीत इतिहास उपलब्ध नहीं',
    banner: {
      title: '7-दिवसीय परीक्षण सक्रिय',
      remaining: '{{days}} दिन शेष',
      credits: 'क्रेडिट उपलब्ध',
      upgradeNow: 'अभी अपग्रेड करें',
    },
    welcome: {
      title: 'निःशुल्क परीक्षण में आपका स्वागत है!',
      desc: '100 क्रेडिट के साथ 7 दिनों के लिए हमारे AI सहायक का निःशुल्क परीक्षण करें। प्रश्न पूछें और संभावनाओं की खोज करें!',
    },
    info: {
      title: 'परीक्षण सीमाएँ',
      credits: '7 दिनों के लिए 100 क्रेडिट',
      noHistory: 'कोई बातचीत इतिहास नहीं',
      noSettings: 'सीमित सुविधाएँ',
      upgrade: 'पूर्ण सुविधाओं के लिए अपग्रेड करें',
    },
  },

  // ─── सेटिंग्स पृष्ठ ────────────────────────────────────────────────────────────
  'settings.title': 'सेटिंग्स',
  'settings.subtitle': 'अपना खाता और प्राथमिकताएँ प्रबंधित करें',
  'settings.backToOverview': 'अवलोकन पर वापस जाएं',
  'settings.subscriptionLink': 'सदस्यता और बिलिंग',
  'settings.saved': 'परिवर्तन सफलतापूर्वक सहेजे गए',
  'settings.changesSaved': 'परिवर्तन सहेजे गए',
  'settings.saveChanges': 'परिवर्तन सहेजें',
  'settings.dataExported': 'डेटा सफलतापूर्वक निर्यात किया गया',

  // टैब
  'settings.tabs.profile': 'प्रोफ़ाइल',
  'settings.tabs.preferences': 'प्राथमिकताएँ',
  'settings.tabs.notifications': 'सूचनाएँ',
  'settings.tabs.account': 'खाता और योजना',

  // प्रोफ़ाइल
  'settings.profile.changePhoto': 'फोटो बदलें',
  'settings.profile.photoHint': 'JPG, PNG या GIF (अधिकतम 2MB)',
  'settings.profile.uploading': 'अपलोड हो रहा है...',
  'settings.profile.photoUpdated': 'प्रोफ़ाइल फोटो अपडेट की गई!',
  'settings.profile.name': 'नाम',
  'settings.profile.email': 'ईमेल',
  'settings.profile.phone': 'फोन',
  'settings.profile.changePassword': 'पासवर्ड बदलें',
  'settings.profile.currentPassword': 'वर्तमान पासवर्ड',
  'settings.profile.newPassword': 'नया पासवर्ड',
  'settings.profile.confirmPassword': 'पासवर्ड की पुष्टि करें',

  // प्राथमिकताएँ
  'settings.preferences.language': 'भाषा',
  'settings.preferences.chooseLanguage': 'भाषा चुनें',
  'settings.preferences.timezone': 'समय क्षेत्र',
  'settings.preferences.currency': 'मुद्रा',

  // सूचनाएँ
  'settings.notifications.emailTitle': 'ईमेल सूचनाएँ',
  'settings.notifications.email.analysis': 'विश्लेषण पूरा',
  'settings.notifications.email.analysisDesc': 'जब आपका विश्लेषण तैयार हो जाए तो ईमेल प्राप्त करें',
  'settings.notifications.email.credits': 'क्रेडिट अपडेट',
  'settings.notifications.email.creditsDesc': 'क्रेडिट और रीसेट के बारे में सूचनाएँ',
  'settings.notifications.email.billing': 'चालान और भुगतान',
  'settings.notifications.email.billingDesc': 'चालान और योजना परिवर्तनों के बारे में सूचनाएँ',
  'settings.notifications.email.newsletter': 'न्यूज़लेटर',
  'settings.notifications.email.newsletterDesc': 'टिप्स, अपडेट और नई सुविधाएँ',
  'settings.notifications.pushTitle': 'पुश सूचनाएँ',
  'settings.notifications.push.analysis': 'विश्लेषण पूरा',
  'settings.notifications.push.analysisDesc': 'जब विश्लेषण तैयार हो जाए तो ब्राउज़र सूचना',
  'settings.notifications.push.credits': 'क्रेडिट चेतावनी',
  'settings.notifications.push.creditsDesc': 'जब क्रेडिट शेष कम हो तो चेतावनी',

  // खाता
  'settings.account.currentSubscription': 'वर्तमान सदस्यता',
  'settings.account.plan': 'योजना',
  'settings.account.price': 'मूल्य',
  'settings.account.nextBilling': 'अगली बिलिंग',
  'settings.account.manageSubscription': 'सदस्यता और भुगतान प्रबंधित करें',
  'settings.account.dataPrivacy': 'डेटा और गोपनीयता',
  'settings.account.exportData': 'डेटा निर्यात करें',
  'settings.account.deleteAccount': 'खाता हटाएं',

  // हटाने का मोडल
  'settings.deleteModal.title': 'खाता हटाएं?',
  'settings.deleteModal.subtitle': 'सभी डेटा स्थायी रूप से हटा दिया जाएगा।',
  'settings.deleteModal.warning1': 'सभी विश्लेषण और डेटा हटा दिए जाएंगे',
  'settings.deleteModal.warning2': 'सक्रिय सदस्यता तुरंत रद्द कर दी जाएगी',
  'settings.deleteModal.warning3': 'कोई वापसी संभव नहीं',
  'settings.deleteModal.confirmLabel': 'पुष्टि करने के लिए "{{word}}" टाइप करें *',
  'settings.deleteModal.cancel': 'रद्द करें',
  'settings.deleteModal.confirm': 'खाता हटाएं',

  // ─── सदस्यता और बिलिंग ─────────────────────────────────
  'sub.backToOverview': 'अवलोकन पर वापस जाएं',
  'sub.settings': 'सेटिंग्स',
  'sub.title': 'सदस्यता और बिलिंग',
  'sub.subtitle': 'अपनी सदस्यता, भुगतान विधियाँ और चालान प्रबंधित करें',
  'sub.tab.overview': 'अवलोकन',
  'sub.tab.payment': 'भुगतान विधियाँ',
  'sub.tab.billing': 'बिलिंग पता',
  'sub.tab.history': 'भुगतान इतिहास',
  'sub.memberSince': 'सदस्यता प्रारंभ',
  'sub.perMonth': 'प्रति माह',
  'sub.baseCHF': '(CHF {{amount}} आधार)',
  'sub.nextBilling': 'अगली बिलिंग',
  'sub.creditsUsed': 'उपयोग किए गए क्रेडिट',
  'sub.paymentMethod': 'भुगतान विधि',
  'sub.creditUsage': 'क्रेडिट उपयोग',
  'sub.changePlan': 'योजना बदलें',
  'sub.reactivate': 'पुनः सक्रिय करें',
  'sub.cancelSub': 'सदस्यता रद्द करें',
  'sub.manageCards': 'कार्ड प्रबंधित करें',
  'sub.downloadInvoices': 'चालान डाउनलोड करें',
  'sub.invoicesAvailable': '{{count}} चालान PDF के रूप में उपलब्ध',
  'sub.accountSettings': 'खाता सेटिंग्स',
  'sub.profileNotifications': 'प्रोफ़ाइल, सूचनाएँ और अधिक',
  // EUR में मूल्य जानकारी
  'sub.eurInfo': 'मूल्य दिखाए गए',
  'sub.eurLabel': 'यूरो',
  'sub.eurRate': 'दर:',
  'sub.currentRate': 'वर्तमान दर',
  // भुगतान विधियाँ
  'sub.savedCards': 'सहेजे गए कार्ड',
  'sub.newCard': 'नया कार्ड',
  'sub.default': 'डिफ़ॉल्ट',
  'sub.setDefault': 'डिफ़ॉल्ट के रूप में सेट करें',
  'sub.validUntil': 'वैध है',
  'sub.noCards': 'कोई कार्ड सहेजा नहीं गया',
  'sub.addFirstCard': 'पहला कार्ड जोड़ें',
  'sub.securePayments': 'सुरक्षित भुगतान',
  'sub.securePaymentsDesc': 'सभी भुगतान डेटा एन्क्रिप्टेड प्रसारित किया जाता है और हमारे भुगतान प्रदाता के साथ सुरक्षित रूप से संग्रहीत किया जाता है। हम पूर्ण कार्ड नंबर संग्रहीत नहीं करते हैं।',
  // बिलिंग पता
  'sub.billingAddress': 'बिलिंग पता',
  'sub.edit': 'संपादित करें',
  'sub.name': 'नाम',
  'sub.streetAddress': 'सड़क और नंबर',
  'sub.zip': 'पिनकोड',
  'sub.city': 'शहर',
  'sub.country': 'देश',
  'sub.address': 'पता',
  'sub.save': 'सहेजें',
  'sub.cancel': 'रद्द करें',
  'sub.country.switzerland': 'स्विट्जरलैंड',
  'sub.country.germany': 'जर्मनी',
  'sub.country.austria': 'ऑस्ट्रिया',
  'sub.country.netherlands': 'नीदरलैंड',
  'sub.country.belgium': 'बेल्जियम',
  // भुगतान इतिहास
  'sub.paymentHistory': 'भुगतान इतिहास',
  'sub.allInvoicesPDF': 'लोगो के साथ सभी चालान PDF के रूप में डाउनलोड करें',
  'sub.downloadAll': 'सभी डाउनलोड करें',
  'sub.eurInvoiceNote': 'चालान हमेशा CHF में जारी किए जाते हैं। प्रदर्शित EUR राशियाँ केवल संदर्भ के लिए हैं।',
  'sub.date': 'तारीख',
  'sub.description': 'विवरण',
  'sub.net': 'शुद्ध',
  'sub.vat': 'वैट',
  'sub.total': 'कुल',
  'sub.status': 'स्थिति',
  'sub.pdf': 'PDF',
  'sub.invoices': 'चालान',
  'sub.totalAmount': 'कुल राशि',
  // योजना बदलें मोडल
  'sub.changePlanTitle': 'योजना बदलें',
  'sub.current': 'वर्तमान',
  'sub.month': '/माह',
  'sub.showLess': 'कम दिखाएं',
  'sub.showMore': '+{{count}} अधिक',
  'sub.switchPlan': 'योजना बदलें',
  'sub.eurPriceNote': 'मूल्य EUR में दिखाए गए ({{note}})। बिलिंग CHF में है।',
  // रद्द करें मोडल
  'sub.cancelTitle': 'वास्तव में सदस्यता रद्द करें?',
  'sub.cancelIrreversible': 'यह क्रिया पूर्ववत नहीं की जा सकती।',
  'sub.cancelWarning1': 'सभी शेष क्रेडिट समाप्त हो जाएंगे',
  'sub.cancelWarning2': 'मुफ्त योजना पर डाउनग्रेड',
  'sub.cancelWarning3': 'सभी प्रीमियम सुविधाओं का नुकसान',
  'sub.pauseInstead': 'वैकल्पिक: सदस्यता रोकें?',
  'sub.pauseDesc': 'इसके बजाय अपनी सदस्यता रोकें और अपना डेटा रखें।',
  'sub.preferPause': 'रोकना पसंद करेंगे',
  'sub.cancelReason': 'रद्द करने का कारण',
  'sub.selectReason': 'कृपया चुनें...',
  'sub.reason.tooExpensive': 'बहुत महंगा',
  'sub.reason.notUsing': 'पर्याप्त उपयोग नहीं कर रहा',
  'sub.reason.missingFeatures': 'सुविधाओं की कमी',
  'sub.reason.foundAlternative': 'एक विकल्प मिल गया',
  'sub.reason.other': 'अन्य',
  'sub.confirmType': 'पुष्टि: "CANCEL" टाइप करें *',
  'sub.cancelNow': 'अभी रद्द करें',
  // कार्ड जोड़ें मोडल
  'sub.addCardTitle': 'नया कार्ड जोड़ें',
  'sub.cardHolder': 'कार्ड धारक *',
  'sub.cardNumber': 'कार्ड नंबर *',
  'sub.expiryDate': 'समाप्ति तिथि *',
  'sub.addCard': 'कार्ड जोड़ें',
  // कार्ड बदलें मोडल
  'sub.choosePayment': 'भुगतान विधि चुनें',
  'sub.active': 'सक्रिय',
  'sub.close': 'बंद करें',
  // टोस्ट संदेश
  'sub.toast.cancelled': 'आपकी सदस्यता बिलिंग अवधि के अंत में रद्द कर दी गई है।',
  'sub.toast.reactivated': 'आपकी सदस्यता सफलतापूर्वक पुनः सक्रिय कर दी गई है!',
  'sub.toast.planChanged': 'योजना सफलतापूर्वक {{plan}} में बदल दी गई!',
  'sub.toast.defaultChanged': 'डिफ़ॉल्ट भुगतान विधि बदल दी गई।',
  'sub.toast.cannotDeleteDefault': 'डिफ़ॉल्ट कार्ड हटाया नहीं जा सकता।',
  'sub.toast.cardRemoved': 'कार्ड हटा दिया गया है।',
  'sub.toast.fillAll': 'कृपया सभी फ़ील्ड भरें।',
  'sub.toast.cardAdded': 'नया कार्ड सफलतापूर्वक जोड़ा गया!',
  'sub.toast.billingSaved': 'बिलिंग पता सहेजा गया।',
  'sub.toast.invoiceDownloaded': 'चालान {{id}} डाउनलोड किया गया!',
  'sub.toast.pdfError': 'PDF बनाने में त्रुटि।',
  // चैट इंटरफ़ेस
  'sub.notEnoughCredits': 'पर्याप्त क्रेडिट नहीं',
  'sub.needCredits': 'प्रति प्रश्न के लिए आपको कम से कम {{count}} क्रेडिट की आवश्यकता है।',
  'sub.creditsLow': 'क्रेडिट कम हो रहे हैं',
  'sub.questionsLeft': '{{count}} प्रश्न संभव हैं।',
  'sub.plan': 'योजना',
  'sub.base': 'आधार',
  'sub.unlimited': 'असीमित',
  'sub.status.active': 'सक्रिय',
  'sub.status.cancelled': 'रद्द',
  'sub.status.paused': 'रोका गया',
  'sub.invoice': 'चालान',
  'sub.from': 'से',
  'sub.to': 'को',
  'sub.vatId': 'वैट आईडी',
  'sub.tel': 'टेल',
  'sub.invoiceDate': 'चालान तिथि',
  'sub.invoiceNumber': 'चालान संख्या',
  'sub.paymentStatus': 'भुगतान स्थिति',
  'sub.creditCard': 'क्रेडिट कार्ड',
  'sub.quantity': 'मात्रा',
  'sub.price': 'मूल्य',
  'sub.amount': 'राशि',
  'sub.subtotal': 'उप-योग',
  'sub.bank': 'बैंक',
  'sub.card': 'कार्ड',
  'sub.cvc': 'सीवीसी',
  'sub.cardHolderPlaceholder': 'जॉन डो',

  // ─── एडमिन पैनल ─────────────────────────────────────────────────────────────
  'admin.title': 'एडमिन डैशबोर्ड',
  'admin.subtitle': 'नियंत्रण केंद्र',
  'admin.superAdmin': 'सुपर एडमिन',
  'admin.logout': 'साइन आउट',
  'admin.tabs.users': 'उपयोगकर्ता प्रबंधन',
  'admin.tabs.downgrades': 'डाउनग्रेड',
  'admin.tabs.tips': 'दिन की टिप',
  'admin.tabs.coupons': 'कूपन कोड',
  'admin.tabs.website': 'वेबसाइट संपादक',
  'admin.tabs.ai': 'AI सेटिंग्स',
  'admin.tabs.transactions': 'लेन-देन लॉग',
  'admin.tabs.stats': 'आंकड़े',
  'admin.users.searchPlaceholder': 'उपयोगकर्ता खोजें (ईमेल या नाम)...',
  'admin.users.manageSubscription': 'सदस्यता प्रबंधित करें',
  'admin.users.grantFree': 'मुफ्त खाता प्रदान करें',
  'admin.users.blockUser': 'उपयोगकर्ता को ब्लॉक करें',
  'admin.users.unblockUser': 'उपयोगकर्ता को अनब्लॉक करें',
  'admin.users.cancellationPlaceholder': 'सदस्यता क्यों रद्द की जा रही है?',
  'admin.users.selectPlan': 'योजना चुनें',
  'admin.users.subChanged': '{{name}} की सदस्यता {{plan}} में बदल दी गई',
  'admin.users.noReasonGiven': 'कोई कारण नहीं दिया गया',
  'admin.users.subCancelled': '{{name}} की सदस्यता रद्द कर दी गई ({{date}} तक वैध)',
  'admin.users.paused': 'रोका गया',
  'admin.users.subPaused': '{{name}} की सदस्यता रोक दी गई है',
  'admin.users.subReactivated': '{{name}} की सदस्यता पुनः सक्रिय कर दी गई है',
  'admin.users.freeAccount': 'मुफ्त खाता',
  'admin.users.blocked': 'ब्लॉक किया गया',
  'admin.users.cancelledExpiring': 'रद्द (समाप्त हो रहा)',
  'admin.users.cancelledOn': 'रद्द:',
  'admin.users.endsOn': 'समाप्त:',
  'admin.users.daysRemaining': 'दिन शेष',
  'admin.users.expired': '(समाप्त)',
  'admin.users.total': 'कुल:',
  'admin.users.usersLabel': 'उपयोगकर्ता',
  'admin.users.free': 'मुफ्त',
  'admin.users.block': 'ब्लॉक करें',
  'admin.users.unblock': 'अनब्लॉक करें',
  'admin.users.selectAction': 'कार्रवाई चुनें',
  'admin.users.cancelSub': 'सदस्यता रद्द करें',
  'admin.users.cancelSubDesc': 'माह के अंत में रद्द',
  'admin.users.pauseSub': 'सदस्यता रोकें',
  'admin.users.pauseSubDesc': 'अस्थायी रोक',
  'admin.users.changePlan': 'योजना बदलें',
  'admin.users.changePlanDesc': 'दूसरी योजना पर स्विच करें',
  'admin.users.reactivateSub': 'सदस्यता पुनः सक्रिय करें',
  'admin.users.reactivateDesc': 'रद्द करना पूर्ववत करें',
  'admin.users.alreadyCancelled': 'सदस्यता पहले ही रद्द कर दी गई है',
  'admin.users.planLabel': 'योजना',
  'admin.users.cancellationReasonOpt': 'रद्द करने का कारण (वैकल्पिक)',
  'admin.users.cancelInfo1': 'सदस्यता समाप्त होगी',
  'admin.users.cancelInfo2': '(माह के अंत में)। तब तक उपयोगकर्ता के पास पूर्ण पहुंच है। कोई वापसी नहीं।',
  'admin.users.newPlan': 'नई योजना',
  'admin.users.warning': 'चेतावनी',
  'admin.users.blockDesc': 'उपयोगकर्ता तुरंत लॉग आउट हो जाएगा और दोबारा लॉगिन नहीं कर सकता। सभी सक्रिय सत्र समाप्त कर दिए जाएंगे।',
  'admin.users.confirmUnblock': 'अनब्लॉक की पुष्टि करें',
  'admin.users.unblockDesc': 'उपयोगकर्ता फिर से लॉगिन कर सकता है और सभी सुविधाओं का उपयोग कर सकता है।',
  'admin.users.afterBlock': 'ब्लॉक करने के बाद:',
  'admin.users.afterUnblock': 'अनब्लॉक करने के बाद:',
  'admin.users.noAccountAccess': 'कोई खाता पहुंच नहीं',
  'admin.users.noNewAnalyses': 'कोई नया विश्लेषण संभव नहीं',
  'admin.users.creditsStored': 'क्रेडिट और इतिहास संग्रहीत रहते हैं',
  'admin.users.accessRestored': 'खाता पहुंच बहाल',
  'admin.users.allFeaturesAvail': 'सभी सुविधाएँ फिर से उपलब्ध',
  'admin.users.creditsPreserved': 'क्रेडिट और इतिहास संरक्षित',
  'admin.users.downgrade': 'योजना डाउनग्रेड करें',
  'admin.users.grantFreeBtn': 'मुफ्त प्रदान करें',
  'admin.users.durationMonths': 'अवधि (महीने)',
  'admin.users.months': 'महीने',
  'admin.users.freePlan': 'मुफ्त',
  'admin.users.freeSummary': 'प्राप्त करता है',
  'admin.users.withCredits': 'के साथ',
  'admin.users.credits': 'क्रेडिट',
  'admin.users.subInfo': 'सदस्यता जानकारी',
  'admin.users.currentPlan': 'वर्तमान योजना',
  'admin.users.joined': 'शामिल हुए',
  'admin.users.totalSpent': 'कुल खर्च',
  'admin.users.paymentMethod': 'भुगतान विधि',
  'admin.users.validThrough': 'इसके माध्यम से वैध',
  'admin.users.billingAddress': 'बिलिंग पता',
  'admin.users.transactionHistory': 'लेन-देन इतिहास',
  'admin.users.cancellationDate': 'रद्द करने की तिथि',
  'admin.users.validUntil': 'तक वैध (माह के अंत तक)',
  'admin.users.cancellationReason': 'रद्द करने का कारण',
  'admin.users.noReason': 'कोई कारण नहीं दिया गया',
  'admin.users.timeRemaining': 'शेष समय',
  'admin.users.daysUntilDeactivation': 'निष्क्रियता तक दिन',
  'admin.table.user': 'उपयोगकर्ता',
  'admin.table.plan': 'योजना',
  'admin.table.subStatus': 'सदस्यता स्थिति',
  'admin.table.cancellation': 'रद्द',
  'admin.table.payment': 'भुगतान विधि',
  'admin.table.spending': 'खर्च',
  'admin.table.actions': 'कार्रवाइयाँ',
  'admin.actions.viewDetails': 'विवरण देखें',
  'admin.actions.manageSubscription': 'सदस्यता प्रबंधित करें',
  'admin.actions.grantFree': 'मुफ्त पहुंच प्रदान करें',
  'admin.actions.block': 'उपयोगकर्ता को ब्लॉक करें',
  'admin.actions.unblock': 'उपयोगकर्ता को अनब्लॉक करें',
  'admin.actions.cancel': 'रद्द करें',
  'admin.actions.save': 'सहेजें',
  'admin.actions.delete': 'हटाएं',
  'admin.actions.confirm': 'पुष्टि करें',
  'admin.actions.done': 'पूर्ण',
  'admin.actions.edit': 'संपादित करें',
  'admin.actions.close': 'बंद करें',
  'admin.table.status': 'स्थिति',
  'admin.filter.all': 'सभी',
  'admin.subscription.active': 'सक्रिय',
  'admin.subscription.cancelled': 'रद्द',
  'admin.subscription.paused': 'रोका गया',
  'admin.subscription.unknown': 'अज्ञात',
  'admin.status.active': 'सक्रिय',
  'admin.status.inactive': 'निष्क्रिय',
  'admin.status.pending': 'लंबित',
  'admin.status.approved': 'स्वीकृत',
  'admin.status.rejected': 'अस्वीकृत',
  'admin.coupons.title': 'कूपन प्रबंधन',
  'admin.coupons.subtitle': 'कूपन कोड बनाएं और प्रबंधित करें',
  'admin.coupons.newCoupon': 'नया कूपन',
  'admin.coupons.registrationCoupons': 'पंजीकरण कूपन',
  'admin.coupons.trialCoupons': 'परीक्षण पहुंच कूपन',
  'admin.coupons.type': 'प्रकार',
  'admin.coupons.plan': 'योजना',
  'admin.coupons.value': 'मूल्य',
  'admin.coupons.usage': 'उपयोग',
  'admin.coupons.validUntil': 'तक वैध',
  'admin.coupons.created': 'बनाया गया',
  'admin.coupons.actions': 'कार्रवाइयाँ',
  'admin.coupons.copyCode': 'कोड कॉपी करें',
  'admin.coupons.allPlans': 'सभी योजनाएँ',
  'admin.coupons.discount': 'छूट',
  'admin.coupons.days': 'दिन',
  'admin.coupons.months': 'महीने',
  'admin.coupons.free': 'मुफ्त',
  'admin.coupons.unlimited': 'असीमित',
  'admin.coupons.createRegistration': 'पंजीकरण कूपन बनाएं',
  'admin.coupons.createTrial': 'परीक्षण पहुंच कूपन बनाएं',
  'admin.coupons.couponCode': 'कूपन कोड',
  'admin.coupons.codePlaceholder': 'जैसे NF-7X3K9M',
  'admin.coupons.generateCode': 'नया कोड उत्पन्न करें',
  'admin.coupons.alertFillRequired': 'कृपया सभी आवश्यक फ़ील्ड भरें',
  'admin.coupons.alertSelectExpiry': 'कृपया एक समाप्ति तिथि चुनें या "असीमित वैधता" सक्षम करें',
  'admin.coupons.alertCreateError': 'कूपन बनाने में त्रुटि',
  'admin.coupons.confirmDelete': 'क्या आप वाकई इस कूपन को हटाना चाहते हैं?',
  'admin.coupons.discountPercent': 'छूट (%)',
  'admin.coupons.bonusCredits': 'बोनस क्रेडिट',
  'admin.coupons.freeDuration': 'मुफ्त अवधि',
  'admin.coupons.maxUses': 'अधिकतम उपयोग',
  'admin.coupons.expiryDate': 'समाप्ति तिथि',
  'admin.coupons.unlimitedValidity': 'असीमित वैधता',
  'admin.coupons.unlimitedUses': 'असीमित उपयोग',
  'admin.coupons.trialCredits': 'परीक्षण क्रेडिट',
  'admin.coupons.trialDuration': 'परीक्षण अवधि',
  'admin.coupons.typePlaceholder': 'जैसे अर्ली बर्ड, पार्टनर, इन्फ्लुएंसर',
  'admin.coupons.duration': 'अवधि',
  'admin.stats.totalUsers': 'कुल उपयोगकर्ता',
  'admin.stats.monthlyRevenue': 'मासिक राजस्व',
  'admin.stats.activeSubscriptions': 'सक्रिय सदस्यताएँ',
  'admin.stats.average': 'औसत',
  'admin.stats.revenuePerUser': 'प्रति उपयोगकर्ता राजस्व',
  'admin.stats.grossRevenue': 'सकल राजस्व',
  'admin.stats.net': 'शुद्ध',
  'admin.stats.netRevenue': 'शुद्ध राजस्व',
  'admin.stats.churnRate': 'ग्राहक छोड़ने की दर',
  'admin.stats.planDistribution': 'योजना वितरण',
  'admin.stats.users': 'उपयोगकर्ता',
  'admin.stats.revenueByPlan': 'योजना द्वारा राजस्व',
  'admin.stats.recentActivity': 'हालिया गतिविधि',
  'admin.stats.activity1': 'थॉमस वेबर ने बिल्डर में अपग्रेड किया',
  'admin.stats.activity2': 'नए उपयोगकर्ता ने पंजीकरण किया',
  'admin.stats.activity3': 'अन्ना श्मिट ने प्रो में अपग्रेड किया',
  'admin.stats.hoursAgo2': '2 घंटे पहले',
  'admin.stats.hoursAgo5': '5 घंटे पहले',
  'admin.stats.dayAgo1': '1 दिन पहले',
  'admin.stats.couponStats': 'कूपन आंकड़े',
  'admin.stats.totalRedemptions': 'कुल उपयोग',
  'admin.stats.activeCoupons': 'सक्रिय कूपन',
  'admin.stats.registrationRedemptions': 'पंजीकरण उपयोग',
  'admin.stats.trialRedemptions': 'परीक्षण उपयोग',
  'admin.stats.couponDistribution': 'कूपन वितरण',
  'admin.stats.registrationCoupons': 'पंजीकरण कूपन',
  'admin.stats.trialCoupons': 'परीक्षण कूपन',
  'admin.stats.expiredInactive': 'समाप्त/निष्क्रिय',
  'admin.stats.topCoupons': 'उपयोग द्वारा शीर्ष कूपन',
  'admin.stats.redemptions': 'उपयोग',
  'admin.stats.noCouponsRedeemed': 'अभी तक कोई कूपन उपयोग नहीं किया गया',
  'admin.downgrade.pending': 'लंबित',
  'admin.downgrade.refunds': 'वापसी',
  'admin.downgrade.sectionRequests': 'अनुरोध',
  'admin.downgrade.sectionStats': 'आंकड़े',
  'admin.downgrade.sectionRules': 'नियम',
  'admin.downgrade.pendingRequests': 'लंबित अनुरोध',
  'admin.downgrade.approvedRequests': 'स्वीकृत अनुरोध',
  'admin.downgrade.rejectedRequests': 'अस्वीकृत अनुरोध',
  'admin.downgrade.activeRules': 'सक्रिय नियम',
  'admin.downgrade.autoRules': 'स्वचालित डाउनग्रेड नियम',
  'admin.downgrade.autoRulesDesc': 'ऐसे नियम बनाएं जो उपयोग व्यवहार के आधार पर स्वचालित रूप से डाउनग्रेड ट्रिगर करें',
  'admin.downgrade.newRule': 'नया नियम',
  'admin.downgrade.totalRules': 'कुल नियम',
  'admin.downgrade.triggeredActions': 'ट्रिगर की गई कार्रवाइयाँ',
  'admin.downgrade.conditionsAnd': 'शर्तें (AND जुड़ी हुई)',
  'admin.downgrade.action': 'कार्रवाई',
  'admin.downgrade.successTitle': 'डाउनग्रेड सफल!',
  'admin.downgrade.successDesc': 'उपयोगकर्ता को सफलतापूर्वक डाउनग्रेड कर दिया गया है और वापसी संसाधित कर दी गई है।',
  'admin.downgrade.closing': 'बंद हो रहा है...',
  'admin.downgrade.title': 'उपयोगकर्ता को डाउनग्रेड करें',
  'admin.downgrade.currentPlan': 'वर्तमान योजना',
  'admin.downgrade.spending': 'खर्च',
  'admin.downgrade.availablePlans': 'डाउनग्रेड के लिए उपलब्ध योजनाएँ',
  'admin.downgrade.perMonth': 'प्रति माह',
  'admin.downgrade.refundCalc': 'वापसी गणना',
  'admin.downgrade.currentPlanLabel': 'वर्तमान योजना',
  'admin.downgrade.newPlan': 'नई योजना',
  'admin.downgrade.remainingDays': 'शेष दिन',
  'admin.downgrade.daysOf': '30 दिनों में से 15 दिन',
  'admin.downgrade.proRataRefund': 'आनुपातिक वापसी',
  'admin.downgrade.importantNote': 'महत्वपूर्ण नोट',
  'admin.downgrade.warningDesc': 'डाउनग्रेड तुरंत निष्पादित किया जाएगा। उपयोगकर्ता प्रीमियम सुविधाओं तक पहुंच खो देगा और अतिरिक्त क्रेडिट हटा दिए जाएंगे।',
  'admin.downgrade.processing': 'प्रसंस्करण...',
  'admin.downgrade.execute': 'डाउनग्रेड निष्पादित करें',
  'admin.downgrade.notification': 'सूचना',
  'admin.downgrade.noNotification': 'कोई सूचना नहीं',
  'admin.downgrade.daysPeriod': 'दिन की अनुग्रह अवधि',
  'admin.downgrade.created': 'बनाया गया:',
  'admin.downgrade.triggered': 'ट्रिगर किया गया',
  'admin.downgrade.noRules': 'अभी तक कोई नियम नहीं बनाया गया',
  'admin.downgrade.createFirstRule': 'पहला नियम बनाएं',
  'admin.downgrade.editRule': 'नियम संपादित करें',
  'admin.downgrade.createRule': 'नया नियम बनाएं',
  'admin.downgrade.ruleName': 'नियम का नाम',
  'admin.downgrade.description': 'विवरण',
  'admin.downgrade.allConditions': 'शर्तें (सभी पूरी होनी चाहिए)',
  'admin.downgrade.addCondition': 'शर्त जोड़ें',
  'admin.downgrade.type': 'प्रकार',
  'admin.downgrade.value': 'मूल्य',
  'admin.downgrade.fromPlan': 'योजना से',
  'admin.downgrade.toPlan': 'योजना में',
  'admin.condition.inactivity': 'निष्क्रियता',
  'admin.condition.creditUsage': 'क्रेडिट उपयोग',
  'admin.condition.loginFrequency': 'लॉगिन आवृत्ति',
  'admin.condition.featureUsage': 'सुविधा उपयोग',
  'admin.condition.supportTickets': 'समर्थन टिकट',
  'admin.operator.lessThan': 'से कम',
  'admin.operator.greaterThan': 'से अधिक',
  'admin.operator.equals': 'बिल्कुल',
  'admin.operator.between': 'के बीच',
  'admin.unit.days': 'दिन',
  'admin.unit.perMonth': 'प्रति माह',
  'admin.unit.count': 'गणना',
  'admin.transactions.all': 'सभी लेन-देन',
  'admin.transactions.allCards': 'सभी कार्ड',
  'admin.transactions.notFound': 'कोई लेन-देन नहीं मिला',
  'admin.transactions.totalLabel': 'कुल',
  'admin.transactions.transactions': 'लेन-देन',
  'admin.tips.title': 'दिन की टिप',
  'admin.tips.subtitle': 'सभी उपयोगकर्ताओं को दिखाई जाने वाली टिप्स बनाएं और प्रबंधित करें',
  'admin.tips.active': 'सक्रिय',
  'admin.tips.currentlyShown': 'यह टिप वर्तमान में सभी उपयोगकर्ताओं को दिखाई जा रही है',
  'admin.tips.createNew': 'नई टिप बनाएं',
  'admin.tips.generating': 'उत्पन्न हो रहा है...',
  'admin.tips.generateAI': 'AI टिप उत्पन्न करें',
  'admin.tips.titleLabel': 'शीर्षक',
  'admin.tips.titlePlaceholder': 'जैसे दिन की टिप',
  'admin.tips.category': 'श्रेणी',
  'admin.tips.categoryTip': 'टिप',
  'admin.tips.categoryFeature': 'नई सुविधा',
  'admin.tips.categoryProductivity': 'उत्पादकता',
  'admin.tips.categoryUpdate': 'अपडेट',
  'admin.tips.content': 'सामग्री',
  'admin.tips.contentPlaceholder': 'अपनी टिप यहां लिखें...',
  'admin.tips.addTip': 'टिप जोड़ें',
  'admin.tips.allTips': 'सभी टिप्स',
  'admin.tips.noTips': 'अभी तक कोई टिप नहीं बनाई गई',
  'admin.tips.noTipsHint': 'शुरू करने के लिए "AI टिप उत्पन्न करें" पर क्लिक करें',
  'admin.noData': 'कोई डेटा उपलब्ध नहीं',
  'admin.range.7d': '7 दिन',
  'admin.range.30d': '30 दिन',
  'admin.range.90d': '90 दिन',
  'admin.range.1y': '1 वर्ष',
  'admin.actions.saveSettings': 'सेटिंग्स सहेजें',
  'admin.actions.create': 'बनाएं',
  'admin.downgrade.sectionReports': 'रिपोर्ट',
  'admin.downgrade.settings': 'डाउनग्रेड सेटिंग्स',
  'admin.downgrade.autoApprove': 'स्वचालित स्वीकृति',
  'admin.downgrade.autoApproveDesc': 'डाउनग्रेड अनुरोधों को स्वचालित रूप से स्वीकृत करें',
  'admin.downgrade.refundPolicy': 'वापसी नीति',
  'admin.downgrade.prorata': 'आनुपातिक वापसी',
  'admin.downgrade.prorataDesc': 'शेष दिनों के आधार पर आनुपातिक वापसी',
  'admin.downgrade.fullRefund': 'पूर्ण वापसी',
  'admin.downgrade.fullRefundDesc': 'मूल्य अंतर की पूर्ण वापसी',
  'admin.downgrade.noRefund': 'कोई वापसी नहीं',
  'admin.downgrade.noRefundDesc': 'वापसी के बिना डाउनग्रेड',
  'admin.downgrade.daysRemaining15': '(15 दिन शेष के साथ)',
  'admin.downgrade.requestsTitle': 'डाउनग्रेड अनुरोध',
  'admin.downgrade.approvalRate': 'स्वीकृति दर',
  'admin.downgrade.mostCommonTransition': 'सबसे आम परिवर्तन',
  'admin.downgrade.mostCommonReason': 'सबसे आम कारण',
  'admin.downgrade.avgProcessingTime': 'औसत प्रसंस्करण समय',
  'admin.downgrade.avgTimeDesc': 'निर्णय तक का औसत समय',
  'admin.downgrade.totalRefunds': 'कुल वापसी',
  'admin.downgrade.pendingRefunds': 'लंबित वापसी',
  'admin.downgrade.summary': 'सारांश',
  'admin.downgrade.total': 'कुल',
  'admin.downgrade.csvDesc': 'Excel, Google Sheets के लिए',
  'admin.downgrade.downloadCSV': 'CSV के रूप में डाउनलोड करें',
  'admin.downgrade.jsonDesc': 'डेवलपर्स, APIs के लिए',
  'admin.downgrade.downloadJSON': 'JSON के रूप में डाउनलोड करें',
  'admin.downgrade.exportInfo': 'निर्यात में शामिल है',
  'admin.downgrade.entries': 'चयनित अवधि से प्रविष्टियाँ',
  'admin.downgrade.topReasons': 'सबसे आम डाउनग्रेड कारण',
  'admin.downgrade.refundHistory': 'वापसी इतिहास',
  'admin.downgrade.noRefunds': 'अभी तक कोई वापसी नहीं',
  'admin.downgrade.statistics': 'डाउनग्रेड आंकड़े',
  'admin.downgrade.requests': 'अनुरोध',
  'admin.downgrade.monthlyTrend': 'मासिक प्रवृत्ति',
  'admin.downgrade.planTransitions': 'योजना परिवर्तन',
  'admin.downgrade.trend': 'प्रवृत्ति (पिछले माह की तुलना में)',
  'admin.downgrade.trendDesc': 'कम डाउनग्रेड = बेहतर',
  'admin.coupons.allPlansUniversal': 'सभी योजनाएँ (यूनिवर्सल)',
  'admin.coupons.onlyStarter': 'केवल स्टार्टर',
  'admin.coupons.onlyPro': 'केवल प्रो',
  'admin.coupons.onlyBuilder': 'केवल बिल्डर',
  'admin.coupons.allPlansHint': 'यूनिवर्सल कूपन के लिए "सभी योजनाएँ" चुनें',
  'admin.coupons.discountOptional': 'छूट % (वैकल्पिक)',
  'admin.coupons.discountPlaceholder': 'जैसे 50% छूट के लिए 50',
  'admin.coupons.bonusCreditsOptional': 'बोनस क्रेडिट (वैकल्पिक)',
  'admin.coupons.bonusCreditsPlaceholder': 'जैसे 500',
  'admin.coupons.freeDurationOptional': 'मुफ्त अवधि (वैकल्पिक)',
  'admin.coupons.durationPlaceholder': 'जैसे 30',
  'admin.coupons.freeDurationHint': 'जैसे 30 दिन मुफ्त उपयोग',
  'admin.coupons.noLimit': 'कोई उपयोग सीमा नहीं',
  'admin.coupons.noExpiry': 'कोई समाप्ति तिथि नहीं',
  'admin.coupons.creditsPlaceholder': 'जैसे 100',
  'admin.coupons.creditsHint': 'परीक्षण पहुंच के लिए क्रेडिट की संख्या',
  'admin.coupons.trialDurationHint': 'परीक्षण पहुंच कितने समय के लिए वैध है',
  'admin.coupons.autoCalculated': 'परीक्षण अवधि से स्वचालित रूप से गणना की गई',
  'admin.websiteEditor.title': 'वेबसाइट संपादक',
  'admin.websiteEditor.subtitle': 'होमपेज के सभी अनुभाग संपादित करें',
  'admin.websiteEditor.openPreview': 'पूर्वावलोकन खोलें',
  'admin.websiteEditor.group.structure': 'पृष्ठ संरचना',
  'admin.websiteEditor.group.design': 'डिज़ाइन और लेआउट',
  'admin.websiteEditor.group.settings': 'सेटिंग्स',
  'admin.websiteEditor.tab.navbar': 'नेविगेशन',
  'admin.websiteEditor.tab.howitworks': 'यह कैसे काम करता है',
  'admin.websiteEditor.tab.about': 'हमारे बारे में',
  'admin.websiteEditor.tab.pricing': 'मूल्य निर्धारण',
  'admin.websiteEditor.tab.sections': 'अनुभाग',
  'admin.websiteEditor.tab.media': 'मीडिया',
  'admin.websiteEditor.tab.chatwidget': 'हमसे बात करें',
  'admin.websiteEditor.tab.invoice': 'चालान',
  'admin.websiteEditor.tab.legal': 'कानूनी',
  'admin.websiteEditor.tab.seo': 'मूल SEO',
  'admin.websiteEditor.tab.advancedseo': 'उन्नत SEO',
  'admin.websiteEditor.tab.versions': 'संस्करण',
  'admin.hero.title': 'हीरो अनुभाग संपादित करें',
  'admin.hero.subtitle': 'होमपेज के टेक्स्ट, बटन और आंकड़े',
  'admin.hero.reset': 'रीसेट करें',
  'admin.hero.save': 'सहेजें',
  'admin.hero.savedMsg': 'हीरो डेटा सहेजा गया!',
  'admin.hero.badge': 'बैज टेक्स्ट',
  'admin.hero.headings': 'शीर्षक',
  'admin.hero.line1White': 'पंक्ति 1 (सफेद)',
  'admin.hero.line2Gold': 'पंक्ति 2 (सुनहरा)',
  'admin.hero.subtitleSection': 'उपशीर्षक',
  'admin.hero.line1': 'पंक्ति 1',
  'admin.hero.line2': 'पंक्ति 2',
  'admin.hero.buttons': 'बटन',
  'admin.hero.primaryBtn': 'प्राथमिक बटन (सुनहरा)',
  'admin.hero.secondaryBtn': 'द्वितीयक बटन (बॉर्डर)',
  'admin.hero.stats': 'आंकड़े',
  'admin.hero.statN': 'आंकड़ा {{n}}',
  'admin.hero.value': 'मूल्य',
  'admin.hero.label': 'लेबल',
  'admin.hero.previewNote': 'परिवर्तन सहेजने के बाद होमपेज पर दिखाई देंगे। पूर्वावलोकन देखने के लिए पृष्ठ को पुनः लोड करें।',

  // विचार इतिहास
  'history.title': 'विचार इतिहास',
  'history.countLabel': '{{count}} विश्लेषण',
  'history.recentLabel': 'आपके हालिया विश्लेषण',
  'history.exportAll': 'सभी निर्यात करें',
  'history.metrics.marketSize': 'बाजार आकार',
  'history.metrics.competition': 'प्रतिस्पर्धा',
  'history.metrics.startingCapital': 'प्रारंभिक पूंजी',
  'history.metrics.timeToMarket': 'बाजार तक पहुंचने का समय',
  'history.metrics.profitPotential': 'लाभ क्षमता',
  'history.metrics.scalability': 'स्केलेबिलिटी',
  'history.summary.title': 'सारांश',
  'history.download': 'डाउनलोड करें',
  'history.downloadJSON': 'JSON के रूप में सहेजें',
  'history.downloadTXT': 'TXT के रूप में सहेजें',
  'history.downloadPDF': 'PDF के रूप में सहेजें',
  'history.fullAnalysis': 'पूर्ण विश्लेषण',
  'history.searchPlaceholder': 'शीर्षक या टैग द्वारा खोजें...',
  'history.filterAll': 'सभी रेटिंग',
  'history.loading': 'विश्लेषण लोड हो रहे हैं...',
  'history.noResults': 'कोई परिणाम नहीं मिला',
  'history.empty': 'अभी तक कोई विश्लेषण नहीं',
  'history.emptyHint': 'AI सहायक में विश्लेषण शुरू करें',
  'history.delete': 'हटाएं',
  'history.cancel': 'रद्द करें',
  'history.deleteModalTitle': 'विश्लेषण हटाएं?',
  'history.deleteModalDesc': '"{{title}}" स्थायी रूप से हटा दिया जाएगा।',
  'history.errorLoading': 'विश्लेषण लोड करने में त्रुटि',
  'history.deleteSuccess': 'विश्लेषण सफलतापूर्वक हटाया गया',
  'history.deleteError': 'विश्लेषण हटाने में त्रुटि',
  'history.jsonExported': 'JSON निर्यात किया गया',
  'history.txtExported': 'TXT निर्यात किया गया',
  'history.allExported': '{{count}} विचार निर्यात किए गए',
  'history.analysisHeader': 'विचार विश्लेषण',
  'history.titleLabel': 'शीर्षक',
  'history.ratingLabel': 'रेटिंग',
  'history.dateLabel': 'तिथि',
  'history.creditsLabel': 'क्रेडिट',
  'history.analysisSection': 'विश्लेषण',

  // अवलोकन
  'overview.title': 'अवलोकन',
  'overview.last24h': 'पिछले 24 घंटे',
  'overview.analysesToday': 'आज के विश्लेषण',
  'overview.totalAnalyses': 'कुल विश्लेषण',
  'overview.successRate': 'सफलता दर',
  'overview.topRatings': 'शीर्ष रेटिंग',
  'overview.recentActivity': 'हालिया गतिविधि',
  'overview.viewAll': 'सभी देखें',
  'overview.quickAccess': 'त्वरित पहुंच',
  'overview.quick.newAnalysis': 'नया विश्लेषण शुरू करें',
  'overview.quick.newAnalysisDesc': 'नया AI-संचालित क्षेत्र विश्लेषण शुरू करें',
  'overview.quick.myAnalyses': 'मेरे विश्लेषण',
  'overview.quick.myAnalysesDesc': 'सभी पिछले विश्लेषण देखें',
  'overview.quick.buyCredits': 'क्रेडिट खरीदें',
  'overview.quick.buyCreditsDesc': 'अधिक विश्लेषणों के लिए अधिक क्रेडिट',
  'overview.quick.settings': 'सेटिंग्स',
  'overview.quick.settingsDesc': 'प्रोफ़ाइल और प्राथमिकताएँ अनुकूलित करें',
  'overview.unlimitedCredits': 'असीमित क्रेडिट उपलब्ध',
  'overview.creditsAvailable': 'क्रेडिट उपलब्ध',
  'overview.upgradePlan': 'योजना अपग्रेड करें',
  'overview.buyCredits': 'क्रेडिट खरीदें',
  'overview.creditUsage': 'इस माह क्रेडिट उपयोग',
  'overview.available': 'उपलब्ध',

  // --- एडमिन नई कुंजियाँ ---
  'admin.transactions.upgrades': 'अपग्रेड',
  'admin.transactions.downgrades': 'डाउनग्रेड',
  'admin.transactions.visa': 'वीसा',
  'admin.transactions.mastercard': 'मास्टरकार्ड',
  'admin.transactions.amex': 'अमेक्स',

  'admin.users.grantFreeSuccess': '{{name}} को अब {{months}} महीने की मुफ्त {{plan}} योजना मिल गई है',
  'admin.users.blockSuccess': '{{name}} को ब्लॉक कर दिया गया',
  'admin.users.unblockSuccess': '{{name}} को अनब्लॉक कर दिया गया',
  'admin.users.removeFreeSuccess': '{{name}} की मुफ्त स्थिति हटा दी गई',

  'admin.downgrade.plans.builder': 'बिल्डर',
  'admin.downgrade.plans.pro': 'प्रो',
  'admin.downgrade.plans.starter': 'स्टार्टर',
  'admin.downgrade.plans.free': 'मुफ्त',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'नई सुविधा खोजें',
  'admin.tips.productivityBoost': 'उत्पादकता बूस्ट',
  'admin.tips.importantUpdate': 'महत्वपूर्ण अपडेट',
  'admin.tips.tipOfDay': 'दिन की टिप',

  'admin.actions.activate': 'सक्रिय करें',
  'admin.actions.deactivate': 'निष्क्रिय करें',
  'admin.websiteEditor.tab.features': 'विशेषताएँ',
  'admin.websiteEditor.tab.testimonials': 'प्रशंसापत्र',
  'admin.websiteEditor.tab.faq': 'अक्सर पूछे जाने वाले प्रश्न',
  'admin.websiteEditor.tab.cta': 'कार्रवाई के लिए कॉल',
  'admin.websiteEditor.tab.footer': 'फूटर',
  'admin.websiteEditor.tab.design': 'डिज़ाइन',
  'admin.websiteEditor.tab.customcode': 'कस्टम कोड',
  'admin.websiteEditor.tab.socials': 'सोशल मीडिया',
  'admin.websiteEditor.tab.importexport': 'आयात/निर्यात',

  // --- AI सेटिंग्स संपादक ---
  'admin.ai.title': 'AI सहायक सेटिंग्स',
  'admin.ai.subtitle': 'व्यवहार, शैली और विश्लेषण गहराई कॉन्फ़िगर करें',
  'admin.ai.smartWeightingActive': 'स्मार्ट वेटिंग सक्रिय',
  'admin.ai.smartWeightingDesc': 'AI स्वचालित रूप से सभी परिप्रेक्ष्यों को स्मार्ट वेटिंग के साथ जोड़ता है। कई प्रीसेट के साथ, पहले प्रीसेट को अधिक भारित किया जाता है (प्राथमिक प्रीसेट)। आप मैन्युअल रूप से वेटिंग भी समायोजित कर सकते हैं।',
  'admin.ai.modelTitle': 'IdeaVerdict AI मॉडल',
  'admin.ai.modelSubtitle': 'सभी उपयोगकर्ता विश्लेषणों के लिए AI इंजन चुनें',
  'admin.ai.activeModel': 'सक्रिय मॉडल:',
  'admin.ai.activeModelDesc': 'सभी उपयोगकर्ताओं को इस मॉडल से प्रतिक्रियाएँ प्राप्त होती हैं।',
  'admin.ai.recommendations': 'सर्वोत्तम परिणामों के लिए सिफारिशें',
  'admin.ai.new': 'नया',
  'admin.ai.recommendationsDesc': 'सिद्ध प्रीसेट संयोजन सर्वोत्तम विश्लेषण गुणवत्ता के लिए',
  'admin.ai.recommendationsInfo': 'इन संयोजनों का परीक्षण किया गया है और सर्वोत्तम परिणाम देते हैं। इसे सीधे लागू करने के लिए एक सिफारिश पर क्लिक करें।',
  'admin.ai.active': 'सक्रिय',
  'admin.ai.apply': 'लागू करें',
  'admin.ai.avoid': 'टालें',
  'admin.ai.excellentQuality': 'उत्कृष्ट गुणवत्ता',
  'admin.ai.goodQuality': 'अच्छी गुणवत्ता',
  'admin.ai.poorQuality': 'पतला गुणवत्ता - अनुशंसित नहीं',
  'admin.ai.proTips': 'प्रो टिप्स',
  'admin.ai.tip1Title': '2 प्रीसेट इष्टतम हैं:',
  'admin.ai.tip1Desc': 'पतला किए बिना स्पष्ट परिप्रेक्ष्य',
  'admin.ai.tip2Title': 'प्राथमिक प्रीसेट मायने रखता है:',
  'admin.ai.tip2Desc': 'पहले प्रीसेट का सबसे अधिक प्रभाव होता है',
  'admin.ai.tip3Title': 'विपरीतों से बचें:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = विरोधाभासी',
  'admin.ai.tip4Title': 'अधिकतम 3 प्रीसेट:',
  'admin.ai.tip4Desc': '4+ प्रीसेट के साथ परिणाम बहुत सामान्य हो जाता है',
  'admin.ai.warningManyPresets': 'चेतावनी: कई प्रीसेट',
  'admin.ai.warningManyPresetsDesc': 'आपने {{count}} प्रीसेट चुने हैं। यह परिणाम को पतला कर सकता है।',
  'admin.ai.warningRecommend': 'अनुशंसित: अधिकतम 2-3 प्रीसेट',
  'admin.ai.forOptimalResults': 'सर्वोत्तम परिणामों के लिए।',
  'admin.ai.presets': 'प्रीसेट',
  'admin.ai.multiSelect': '(एकाधिक चयन संभव)',
  'admin.ai.presetsDesc': 'एक या अधिक प्रीसेट चुनें। पहला प्रीसेट उच्चतम वेटिंग वाला प्राथमिक प्रीसेट है।',
  'admin.ai.primaryPreset': 'प्राथमिक प्रीसेट',
  'admin.ai.weightControl': 'वेट नियंत्रण',
  'admin.ai.weightControlDesc': 'समायोजित करें कि प्रत्येक प्रीसेट विश्लेषण को कितनी मजबूती से प्रभावित करता है',
  'admin.ai.manual': 'मैन्युअल',
  'admin.ai.automatic': 'स्वचालित',
  'admin.ai.autoWeightingActive': 'स्वचालित वेटिंग सक्रिय:',
  'admin.ai.autoWeightingDesc': 'प्रीसेट की संख्या के आधार पर वेटिंग स्वचालित रूप से अनुकूलित की जाती है।',
  'admin.ai.primary': 'प्राथमिक',
  'admin.ai.totalWeight': 'कुल',
  'admin.ai.shouldBe100': '100% होना चाहिए',
  'admin.ai.normalize': 'सामान्यीकृत करें',
  'admin.ai.combinedSettings': 'संयुक्त सेटिंग्स',
  'admin.ai.presetsCount': 'प्रीसेट',
  'admin.ai.strictness': 'कठोरता',
  'admin.ai.realism': 'यथार्थवाद',
  'admin.ai.creativity': 'रचनात्मकता',
  'admin.ai.detailLevel': 'विवरण स्तर',
  'admin.ai.customInstructions': 'कस्टम निर्देश',
  'admin.ai.customInstructionsDesc': 'अतिरिक्त निर्देश जो प्रीसेट के साथ संयुक्त होते हैं',
  'admin.ai.customInstructionsPlaceholder': 'जैसे "DACH बाजार पर ध्यान केंद्रित करें", "हमेशा ठोस संख्याओं का उपयोग करें", "मौजूदा प्रतिस्पर्धियों के साथ तुलना करें", "हमेशा उदाहरणों के साथ उत्तर दें"...',
  'admin.ai.customInstructionsHint': 'ये निर्देश स्वचालित रूप से चयनित प्रीसेट के साथ संयुक्त होते हैं।',
  'admin.ai.manualFinetuning': 'मैन्युअल फाइन-ट्यूनिंग',
  'admin.ai.manualFinetuningHint': '(वैकल्पिक, प्रीसेट मानों को ओवरराइड करता है)',
  'admin.ai.manualFinetuningDesc': 'यदि आप कुछ फाइन-ट्यून करना चाहते हैं तो संयुक्त मानों को मैन्युअल रूप से समायोजित करें।',
  'admin.ai.tone': 'स्वर',
  'admin.ai.mild': 'हल्का',
  'admin.ai.strict': 'सख्त',
  'admin.ai.creative': 'रचनात्मक',
  'admin.ai.realistic': 'यथार्थवादी',
  'admin.ai.conservative': 'रूढ़िवादी',
  'admin.ai.compact': 'संक्षिप्त',
  'admin.ai.detailed': 'विस्तृत',
  'admin.ai.responseLength': 'प्रतिक्रिया लंबाई',
  'admin.ai.short': 'संक्षिप्त और सटीक',
  'admin.ai.medium': 'मध्यम',
  'admin.ai.long': 'विस्तृत',
  'admin.ai.focusAreas': 'विश्लेषण फोकस क्षेत्र',
  'admin.ai.autoRating': 'स्वचालित रेटिंग',
  'admin.ai.autoRatingDesc': 'प्रत्येक विश्लेषण स्वचालित रूप से एक रेटिंग (अच्छा/मध्यम/बुरा) प्राप्त करता है',
  'admin.ai.showSources': 'स्रोत दिखाएं',
  'admin.ai.showSourcesDesc': 'प्रतिक्रियाओं में डेटा स्रोतों और बाजार डेटा के संदर्भ',
  'admin.ai.hidePreview': 'पूर्वावलोकन छुपाएं',
  'admin.ai.showPreview': 'पूर्वावलोकन दिखाएं',
  'admin.ai.aiBehavior': 'AI व्यवहार',
  'admin.ai.length': 'लंबाई',
  'admin.ai.liveExample': 'लाइव उदाहरण',
  'admin.ai.testSettings': 'अपनी सेटिंग्स का परीक्षण करें',
  'admin.ai.selectExampleQuestion': 'उदाहरण प्रश्न चुनें:',
  'admin.ai.userAsks': 'उपयोगकर्ता पूछता है:',
  'admin.ai.generating': 'AI प्रतिक्रिया उत्पन्न कर रहा है...',
  'admin.ai.generateExample': 'उदाहरण प्रतिक्रिया उत्पन्न करें',
  'admin.ai.aiResponds': 'AI सहायक उत्तर देता है:',
  'admin.ai.generateHint': 'यह देखने के लिए "उदाहरण प्रतिक्रिया उत्पन्न करें" पर क्लिक करें कि AI आपकी सेटिंग्स के साथ कैसे प्रतिक्रिया देता है।',
  'admin.ai.reset': 'रीसेट करें',
  'admin.ai.saved': 'सहेजा गया!',
  'admin.ai.saveSettings': 'सेटिंग्स सहेजें',

  // --- टेबल हेडर ---
  'admin.coupons.code': 'कोड',
  'admin.coupons.credits': 'क्रेडिट',

  // --- AI मॉडल विवरण ---
  'admin.ai.model.standardDesc': 'उच्च गुणवत्ता के साथ संतुलित विश्लेषण। अधिकांश क्षेत्र आकलन और विचार सत्यापन के लिए सबसे अच्छा विकल्प।',
  'admin.ai.model.preciseAnalyses': 'सटीक विश्लेषण',
  'admin.ai.model.bestBalance': 'सर्वोत्तम संतुलन',
  'admin.ai.model.recommended': 'अनुशंसित',
  'admin.ai.model.fastDesc': 'त्वरित क्षेत्र जांच, विचार-विमर्श और प्रारंभिक आकलन के लिए बिजली-तेज प्रतिक्रियाएँ। जब गति मायने रखती है तो आदर्श।',
  'admin.ai.model.fast': 'तेज',
  'admin.ai.model.fastestResponses': 'सबसे तेज प्रतिक्रियाएँ',
  'admin.ai.model.thinkingDesc': 'उन्नत तार्किक सोच के साथ गहन विश्लेषण। जटिल बाजार विश्लेषण, महत्वपूर्ण आकलन और रणनीतिक योजना के लिए।',
  'admin.ai.model.deepestAnalysis': 'गहनतम विश्लेषण',
  'admin.ai.model.logicalThinking': 'तार्किक सोच',
  'admin.ai.model.strategy': 'रणनीति',

  // --- AI प्रीसेट नाम और विवरण ---
  'admin.ai.preset.strict.name': 'सख्त विश्लेषण',
  'admin.ai.preset.strict.desc': 'आलोचनात्मक, तथ्य-आधारित, कोई मीठी बातें नहीं। बेरहमी से कमजोरियों को उजागर करता है।',
  'admin.ai.preset.extreme.name': 'चरम विश्लेषण',
  'admin.ai.preset.extreme.desc': 'अधिकतम कठोरता, निर्दयी आलोचना, सबसे खराब स्थिति पर ध्यान। केवल कठिन वास्तविकता जांच के लिए।',
  'admin.ai.preset.professional.name': 'पेशेवर',
  'admin.ai.preset.professional.desc': 'उद्देश्यपूर्ण, संरचित, संतुलित। एक अनुभवी व्यावसायिक सलाहकार की तरह।',
  'admin.ai.preset.realistic.name': 'यथार्थवादी',
  'admin.ai.preset.realistic.desc': 'ईमानदार और व्यावहारिक। व्यवहार्य कार्यान्वयन और वास्तविक बाजार डेटा पर ध्यान दें।',
  'admin.ai.preset.creative.name': 'रचनात्मक और प्रेरक',
  'admin.ai.preset.creative.desc': 'प्रेरक, विचार-समृद्ध, सकारात्मक। अवसरों और अपरंपरागत रास्तों को ढूंढता है।',
  'admin.ai.preset.balanced.name': 'संतुलित',
  'admin.ai.preset.balanced.desc': 'आलोचना और प्रेरणा का अच्छा मिश्रण। डिफ़ॉल्ट मोड।',
  'admin.ai.preset.investor.name': 'निवेशक परिप्रेक्ष्य',
  'admin.ai.preset.investor.desc': 'एक वेंचर कैपिटलिस्ट की तरह। स्केलिंग, ROI और निकास रणनीति पर ध्यान दें।',
  'admin.ai.preset.startup-coach.name': 'स्टार्टअप कोच',
  'admin.ai.preset.startup-coach.desc': 'संस्थापकों के लिए व्यावहारिक मेंटर। त्वरित कार्यान्वयन और MVP पर ध्यान दें।',
  'admin.ai.preset.market-researcher.name': 'बाजार शोधकर्ता',
  'admin.ai.preset.market-researcher.desc': 'डेटा-संचालित और विश्लेषणात्मक। गहन बाजार और प्रतिस्पर्धी विश्लेषण।',
  'admin.ai.preset.risk-analyst.name': 'जोखिम विश्लेषक',
  'admin.ai.preset.risk-analyst.desc': 'जोखिम और सबसे खराब स्थिति पर ध्यान दें। यथार्थवादी योजना के लिए।',

  // --- फोकस क्षेत्र ---
  'admin.ai.focus.marktanalyse': 'बाजार विश्लेषण',
  'admin.ai.focus.wettbewerb': 'प्रतिस्पर्धा',
  'admin.ai.focus.monetarisierung': 'मुद्रीकरण',
  'admin.ai.focus.risiken': 'जोखिम',
  'admin.ai.focus.finanzen': 'वित्त',
  'admin.ai.focus.skalierung': 'स्केलिंग',
  'admin.ai.focus.innovation': 'नवाचार',
  'admin.ai.focus.trends': 'रुझान',
  'admin.ai.focus.differenzierung': 'विभेदन',
  'admin.ai.focus.umsetzung': 'कार्यान्वयन',
  'admin.ai.focus.zielgruppe': 'लक्षित दर्शक',
  'admin.ai.focus.marketing': 'मार्केटिंग',

  // --- स्वर विकल्प ---
  'admin.ai.tone.direkt': 'प्रत्यक्ष और कठोर',
  'admin.ai.tone.professionell': 'पेशेवर और उद्देश्यपूर्ण',
  'admin.ai.tone.ehrlich': 'ईमानदार और व्यावहारिक',
  'admin.ai.tone.motivierend': 'प्रेरक और सकारात्मक',
  'admin.ai.tone.freundlich': 'मैत्रीपूर्ण और सहायक',
  'admin.ai.tone.akademisch': 'शैक्षणिक और विश्लेषणात्मक',

  // --- उदाहरण प्रश्न ---
  'admin.ai.question.niche': 'आप किस लाभदायक क्षेत्र की सिफारिश करते हैं?',
  'admin.ai.question.evaluate': 'मेरे विचार को रेट करें: कुत्ते के मालिकों के लिए एक ऐप',
  'admin.ai.question.trends': 'वर्तमान में किन रुझानों में क्षमता है?',
  'admin.ai.question.sharpen': 'मैं अपने क्षेत्र को कैसे तेज कर सकता हूँ?',

  'admin.ai.rec.bestCombination.title': '🏆 सर्वोत्तम संयोजन (2 प्रीसेट)',
  'admin.ai.rec.bestCombination.desc': 'आलोचनात्मक लेकिन रचनात्मक, ठोस कार्रवाई चरणों के साथ',
  'admin.ai.rec.bestCombination.useCase': 'अधिकांश विश्लेषणों के लिए अनुशंसित',

  'admin.ai.rec.balancedThree.title': '⚖️ संतुलित (3 प्रीसेट)',
  'admin.ai.rec.balancedThree.desc': 'पेशेवर, यथार्थवादी और निवेशक-अनुकूल',
  'admin.ai.rec.balancedThree.useCase': 'व्यापक व्यावसायिक विश्लेषणों के लिए',

  'admin.ai.rec.creativeDriven.title': '💡 रचनात्मक और प्रेरक (2 प्रीसेट)',
  'admin.ai.rec.creativeDriven.desc': 'व्यावहारिक कार्यान्वयन युक्तियों के साथ प्रेरक',
  'admin.ai.rec.creativeDriven.useCase': 'विचार-विमर्श और मंथन के लिए',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'मेनू खोलें',
  'header.home': 'होम',
  'header.notifications': 'सूचनाएँ',
  'header.settings': 'सेटिंग्स',
  'header.profile': 'प्रोफ़ाइल',
  'sidebar.collapse': 'साइडबार छिपाएं',
  'sidebar.expand': 'साइडबार विस्तृत करें',
  'sidebar.close': 'मेनू बंद करें',
  'sidebar.plan': 'योजना',
  'sidebar.backToWebsite': 'वेबसाइट पर वापस जाएं',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'वापस आने पर स्वागत है',
  'overview.greetingSub': 'आपके फैसला डेस्क पर क्या हो रहा है।',
  'overview.heroCta': 'नया फैसला',
  'overview.currentPlan': 'वर्तमान योजना',
  'overview.creditsLabel': 'क्रेडिट',
  'overview.usedThisCycle': 'इस चक्र में उपयोग',
  'overview.resetsOn': 'रीसेट',
  'overview.unlimitedTitle': 'असीमित',
  'overview.builderPerk': 'आपके पास पूर्ण Builder एक्सेस है — कोई सीमा नहीं।',
  'overview.runOne': 'फैसला चलाएँ',
  'overview.lastVerdicts': 'आपके पिछले 5 फैसले',
  'overview.noActivity': 'अभी कोई फैसला नहीं — अपना पहला विश्लेषण शुरू करें',
  'overview.tipTitle': 'सुझाव',
  'overview.tipBody': 'किसी आइडिया को दो भाषाओं में चलाएँ — यदि एक में फैसला नरम होता है, तो आपकी धारणाएँ स्थानीय हैं, सार्वभौमिक नहीं।',
  'onboard.skip': "छोड़ें",
  'onboard.cta.next': "आगे",
  'onboard.cta.start': "शुरू करें",
  'onboard.s1.title': "IdeaVerdict में आपका स्वागत है",
  'onboard.s1.body': "बनाने से पहले — आपके बिज़नेस आइडिया पर AI का फैसला।",
  'onboard.s2.title': "बेरहमी से ईमानदार फैसले",
  'onboard.s2.body': "न हाइप, न चापलूसी। असली बाज़ार डेटा, असली प्रतिस्पर्धी, असली जोखिम।",
  'onboard.s3.title': "PDF के रूप में Builder Reports",
  'onboard.s3.body': "पूरी आर्किटेक्चर, फाइनेंशियल और गो-टू-मार्केट रणनीति के साथ 25-75 पेज की रिपोर्ट बनाएँ।",
  'onboard.s4.title': "जब आप तैयार हों",
  'onboard.s4.body': "साइन अप करें और एक मिनट के अंदर अपना पहला फैसला पाएँ।",
  'builderReport.title': "आपकी Builder Report बन रही है",
  'builderReport.subtitle': "व्यापक विश्लेषण + डेवलपर ब्रीफ़िंग — तैयार होते ही PDF डाउनलोड हो जाती है।",
  'builderReport.idea': "आपका आइडिया",
  'builderReport.ideaPlaceholder': "अपना बिज़नेस आइडिया लिखें (या ख़ाली छोड़ें ताकि पिछली चर्चा का आइडिया इस्तेमाल हो)…",
  'builderReport.cta': "रिपोर्ट बनाएँ",
  'builderReport.credits': "क्रेडिट",
  'builderReport.deductedNow': "सफलता पर काटे जाएँगे",
  'builderReport.dontClose': "कृपया यह विंडो बंद न करें — जनरेट होने में 30-90 सेकंड लग सकते हैं।",
  'builderReport.done': "PDF डाउनलोड हो गई — अपना डाउनलोड फ़ोल्डर देखें।",
  'builderReport.failed': "जनरेशन विफल",
  'builderReport.close': "बंद करें",
  'builderReport.cancel': "रद्द करें",
  'builderReport.running': "बन रही है…",
  'builderReport.retry': "फिर कोशिश करें",
  'builderReport.unknownError': "जनरेशन फेल। आपके क्रेडिट वापस कर दिए जाने चाहिए।",
  'builderReport.signInRequired': "रिपोर्ट बनाने के लिए साइन इन ज़रूरी है।",
  'builderReport.ideaRequired': "कृपया अपना आइडिया लिखें ताकि AI के पास विश्लेषण के लिए कुछ हो।",
  'builderReport.fromChat': "आपकी मौजूदा बातचीत से",
  'builderReport.noIdeaDetected': "जिस आइडिया पर हम चर्चा कर रहे हैं, उसी का इस्तेमाल हो रहा है।",
  'builderReport.contextHint': "AI इस चैट की हर चीज़ का इस्तेमाल करेगा — कोई नया आइडिया नहीं गढ़ा जाएगा।",
  'builderReport.step.core': "कोर विश्लेषण तैयार हो रहा है",
  'builderReport.step.market': "विस्तृत मार्केट विश्लेषण जोड़ा जा रहा है",
  'builderReport.step.tech': "तकनीकी आर्किटेक्चर जोड़ी जा रही है",
  'builderReport.step.financials': "फाइनेंशियल मॉडल जोड़े जा रहे हैं",
  'builderReport.step.compet': "कॉम्पिटिटिव इंटेलिजेंस जोड़ी जा रही है",
  'builderReport.step.gtm': "गो-टू-मार्केट रणनीति जोड़ी जा रही है",
  'builderReport.step.deepdive': "इंडस्ट्री डीप-डाइव जोड़ी जा रही है",
  'builderReport.step.pdf': "PDF कंपाइल हो रही है…",
  'briefing.title': "आपकी Developer Briefing बन रही है",
  'briefing.subtitle': "11-सेक्शन तकनीकी ब्रीफ़िंग — तैयार होते ही PDF डाउनलोड हो जाती है।",
  'briefing.ideaPlaceholder': "अपना बिज़नेस आइडिया लिखें (या ख़ाली छोड़ें ताकि पिछली चर्चा का आइडिया इस्तेमाल हो)…",
  'briefing.cta': "ब्रीफ़िंग बनाएँ",
  'briefing.step.core': "डेवलपर ब्रीफ़िंग तैयार हो रही है",
  'briefing.step.pdf': "PDF कंपाइल हो रही है…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "ज़्यादा क्रेडिट + 50-पेज की रिपोर्ट",
  'pricing.gold.credits': "प्रति माह 12,500 क्रेडिट",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "सर्वोच्च टियर + 75-पेज की रिपोर्ट",
  'pricing.platinum.credits': "प्रति माह 15,000 क्रेडिट",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "hi" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "सिर्फ़ {{count}} क्रेडिट बचे!",
  'trial.upgradeNow': "अभी अपग्रेड करें",
  'trial.upgradeNowArrow': "अभी अपग्रेड करें →",
  'trial.creditsExhausted': "क्रेडिट ख़त्म",
  'trial.upgradeForUnlimited': "अनलिमिटेड के लिए अपग्रेड करें",
  'trial.noCreditsPlaceholder': "कोई क्रेडिट नहीं बचा…",
  'hero.badgeHonest': "ईमानदार, निष्पक्ष AI",
  'hero.badge60sec': "60 सेकंड में फैसला",
  'hero.badge20Lang': "20+ भाषाएँ",
  'hero.widget.label': "Idea Verdict",
  'hero.widget.passed': "पास",
  'hero.widget.demoIdea': "मेडिकल छात्रों के लिए AI ट्यूटर",
  'hero.widget.market': "मार्केट",
  'hero.widget.demand': "मांग",
  'hero.widget.competition': "प्रतिस्पर्धा",
  'hero.widget.verdictReady': "फैसला तैयार · 47 सेकंड",
  'hero.widget.riskFlagged': "जोखिम चिह्नित",
  'hero.widget.crowdedMarket': "भीड़भाड़ वाला मार्केट · 4 स्थापित खिलाड़ी",
  'hero.widget.suggestedPivot': "सुझाया गया पिवट",
  'hero.widget.nicheBySpecialty': "विशेषज्ञता के अनुसार निच",
  'hero.widget.feasibilityGain': "+38% व्यवहार्यता",
  'hero.widget.analysisDone': "विश्लेषण पूरा",
  'hero.widget.metrics56': "6 में से 5 मेट्रिक",
  'hero.stats.verdictSpeed': "फैसले की गति",
  'cta.badge': "60 सेकंड में फैसला",
  'cta.subtitleEnd': "अंदाज़े के बिना।",
  'cta.signinPrompt': "पहले से अकाउंट है? साइन इन करें",
  'cta.trustTrial': "7-दिन का मुफ़्त ट्रायल",
  'cta.trustNoCard': "कार्ड की ज़रूरत नहीं",
  'cta.trustCancel': "कभी भी रद्द करें",
  'footer.themeLabel': "थीम:",
  'footer.lightMode': "लाइट मोड",
  'footer.darkMode': "डार्क मोड",
  'footer.sectionProduct': "प्रोडक्ट",
  'footer.sectionLegal': "लीगल",
  'nav.switchLight': "लाइट मोड पर स्विच करें",
  'nav.switchDark': "डार्क मोड पर स्विच करें",
  'features.badge': "क्यों IdeaVerdict",
  'features.mainFeatureLabel': "हेडलाइन",
  'chatError.planRestriction': "इस सुविधा के लिए उच्च प्लान चाहिए।",
  'chatError.creditDeduction': "भुगतान असफल। कृपया पुनः प्रयास करें।",
  'chatError.aiService': "AI सेवा अस्थायी रूप से अनुपलब्ध है। आपके क्रेडिट नहीं काटे गए। कृपया पुनः प्रयास करें।",
  'chatError.parseError': "अप्रत्याशित प्रतिक्रिया प्रारूप मिला। कृपया पुनः प्रयास करें।",
  'chatError.sessionExpired': "आपका सत्र समाप्त हो गया। कृपया फिर से साइन इन करें।",
  'chatError.timeout': "अनुरोध में बहुत अधिक समय लगा। कृपया पुनः प्रयास करें।",
  'chatError.generic': "प्रतिक्रिया प्राप्त नहीं हुई। कृपया पुनः प्रयास करें।",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "hi" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "सिर्फ़ {{count}} क्रेडिट बचे!",
  'trial.outOfCredits': "क्रेडिट ख़त्म",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "भीड़भाड़ वाला मार्केट · 4 स्थापित खिलाड़ी",
  'hero.widget.nicheBySpec': "विशेषज्ञता के अनुसार निच",
  'hero.widget.feasibilityUp': "+38% व्यवहार्यता",
  'hero.widget.fiveOfSix': "6 में से 5 मेट्रिक",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25-पन्नों की Builder Report",
  'pricing.gold.report': "50-पन्नों की Builder Report",
  'pricing.platinum.report': "75-पन्नों की Builder Report",
  'auth.bestValue': "सर्वोत्तम मूल्य",
  'auth.elite': "एलीट",
  'builderReport.friendlyError': "हम इस बार आपकी रिपोर्ट पूरी नहीं कर सके। आपके क्रेडिट नहीं काटे गए — कृपया कुछ क्षणों में पुनः प्रयास करें।",
  'builderReport.persistHint': "यदि यह समस्या बनी रहे, तो support@ideaverdict.ai पर संपर्क करें।",
};
